/* eslint-disable */
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */
/** @typedef {{}} Auth_BannedInputs */
/** @typedef {{}} Auth_Mail_Send_FailedInputs */
/** @typedef {{ seconds: NonNullable<unknown> }} Auth_Resend_Too_SoonInputs */
/** @typedef {{}} Cv_As_BroadcastInputs */
/** @typedef {{}} Cv_BroadcastInputs */
/** @typedef {{}} Cv_Broadcast_HintInputs */
/** @typedef {{}} Cv_Broadcast_No_ReplyInputs */
/** @typedef {{}} Cv_CancelInputs */
/** @typedef {{}} Cv_Cannot_PostInputs */
/** @typedef {{}} Cv_Col_Last_MessageInputs */
/** @typedef {{}} Cv_Col_NameInputs */
/** @typedef {{}} Cv_Col_SpaceInputs */
/** @typedef {{}} Cv_Col_UpdatedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cv_Dm_EmptyInputs */
/** @typedef {{ names: NonNullable<unknown> }} Cv_Dm_Empty_GroupInputs */
/** @typedef {{}} Cv_Dm_Empty_SelfInputs */
/** @typedef {{}} Cv_Dm_Empty_UnknownInputs */
/** @typedef {{ when: NonNullable<unknown> }} Cv_Dm_LastInputs */
/** @typedef {{ count: NonNullable<unknown> }} Cv_Dm_MembersInputs */
/** @typedef {{}} Cv_Dm_MenuInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cv_Dm_Self_NameInputs */
/** @typedef {{}} Cv_DmsInputs */
/** @typedef {{}} Cv_Dms_EmptyInputs */
/** @typedef {{}} Cv_Dms_None_MatchInputs */
/** @typedef {{}} Cv_Dms_None_UnreadInputs */
/** @typedef {{}} Cv_Dms_StartInputs */
/** @typedef {{}} Cv_EditInputs */
/** @typedef {{}} Cv_Edit_LabelInputs */
/** @typedef {{}} Cv_Emoji_AddInputs */
/** @typedef {{}} Cv_Emoji_Add_SectionInputs */
/** @typedef {{}} Cv_Emoji_Cannot_AddInputs */
/** @typedef {{}} Cv_Emoji_ChooseInputs */
/** @typedef {{}} Cv_Emoji_Choose_ImageInputs */
/** @typedef {{}} Cv_Emoji_EmptyInputs */
/** @typedef {{ max: NonNullable<unknown> }} Cv_Emoji_FullInputs */
/** @typedef {{}} Cv_Emoji_ImageInputs */
/** @typedef {{ kb: NonNullable<unknown> }} Cv_Emoji_Image_NoteInputs */
/** @typedef {{}} Cv_Emoji_ListInputs */
/** @typedef {{}} Cv_Emoji_NameInputs */
/** @typedef {{}} Cv_Emoji_Name_NoteInputs */
/** @typedef {{}} Cv_Emoji_Name_RuleInputs */
/** @typedef {{}} Cv_Emoji_No_ImageInputs */
/** @typedef {{}} Cv_Emoji_Pick_ImageInputs */
/** @typedef {{}} Cv_Emoji_RemoveInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cv_Emoji_Remove_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cv_Emoji_Remove_LabelInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cv_Emoji_Remove_TitleInputs */
/** @typedef {{ kb: NonNullable<unknown> }} Cv_Emoji_Too_LargeInputs */
/** @typedef {{}} Cv_FilterInputs */
/** @typedef {{}} Cv_Filter_AllInputs */
/** @typedef {{}} Cv_Filter_BroadcastsInputs */
/** @typedef {{}} Cv_Filter_SpaceInputs */
/** @typedef {{}} Cv_Filter_Space_AllInputs */
/** @typedef {{}} Cv_Filter_UnreadInputs */
/** @typedef {{}} Cv_InboxInputs */
/** @typedef {{}} Cv_Inbox_Reason_PostedInputs */
/** @typedef {{}} Cv_Load_FailedInputs */
/** @typedef {{}} Cv_Loading_OlderInputs */
/** @typedef {{}} Cv_Mark_ReadInputs */
/** @typedef {{}} Cv_Me_DmsInputs */
/** @typedef {{ count: NonNullable<unknown> }} Cv_Members_CountInputs */
/** @typedef {{ count: NonNullable<unknown> }} Cv_Members_MoreInputs */
/** @typedef {{}} Cv_Mention_Cannot_SeeInputs */
/** @typedef {{}} Cv_Message_MenuInputs */
/** @typedef {{}} Cv_MoveInputs */
/** @typedef {{}} Cv_Move_ActionInputs */
/** @typedef {{}} Cv_NarrowInputs */
/** @typedef {{}} Cv_Narrow_NameInputs */
/** @typedef {{}} Cv_Narrow_TitleInputs */
/** @typedef {{}} Cv_New_DmInputs */
/** @typedef {{}} Cv_New_Dm_ChosenInputs */
/** @typedef {{ max: NonNullable<unknown> }} Cv_New_Dm_LimitInputs */
/** @typedef {{}} Cv_New_Dm_NobodyInputs */
/** @typedef {{}} Cv_New_Dm_PeopleInputs */
/** @typedef {{}} Cv_New_Dm_SearchInputs */
/** @typedef {{}} Cv_New_Dm_StartInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cv_New_Dm_UnpickInputs */
/** @typedef {{}} Cv_New_TopicInputs */
/** @typedef {{}} Cv_New_Topic_HintInputs */
/** @typedef {{}} Cv_New_Topic_InInputs */
/** @typedef {{}} Cv_No_DescriptionInputs */
/** @typedef {{}} Cv_No_SpaceInputs */
/** @typedef {{}} Cv_Not_FoundInputs */
/** @typedef {{}} Cv_PinInputs */
/** @typedef {{}} Cv_Pin_DownInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cv_Pin_Down_LabelInputs */
/** @typedef {{}} Cv_Pin_GoneInputs */
/** @typedef {{}} Cv_Pin_UpInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cv_Pin_Up_LabelInputs */
/** @typedef {{}} Cv_PinsInputs */
/** @typedef {{}} Cv_Pins_EmptyInputs */
/** @typedef {{}} Cv_Pins_Empty_CanInputs */
/** @typedef {{}} Cv_Post_LabelInputs */
/** @typedef {{}} Cv_Post_PlaceholderInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cv_Post_Placeholder_DmInputs */
/** @typedef {{ names: NonNullable<unknown> }} Cv_Post_Placeholder_Dm_GroupInputs */
/** @typedef {{}} Cv_Post_Placeholder_Dm_SelfInputs */
/** @typedef {{}} Cv_ReactInputs */
/** @typedef {{}} Cv_React_NoneInputs */
/** @typedef {{}} Cv_React_SearchInputs */
/** @typedef {{}} Cv_Reaction_CheckInputs */
/** @typedef {{}} Cv_Reaction_EyeInputs */
/** @typedef {{ name: NonNullable<unknown>, count: NonNullable<unknown> }} Cv_Reaction_LabelInputs */
/** @typedef {{}} Cv_ReactionsInputs */
/** @typedef {{}} Cv_Recent_TopicsInputs */
/** @typedef {{}} Cv_RemoveInputs */
/** @typedef {{}} Cv_Remove_BodyInputs */
/** @typedef {{}} Cv_Remove_TitleInputs */
/** @typedef {{}} Cv_RenameInputs */
/** @typedef {{}} Cv_Rename_ActionInputs */
/** @typedef {{}} Cv_SaveInputs */
/** @typedef {{}} Cv_Save_FailedInputs */
/** @typedef {{}} Cv_Send_FailedInputs */
/** @typedef {{}} Cv_Settings_EmojiInputs */
/** @typedef {{}} Cv_Settings_Emoji_DescriptionInputs */
/** @typedef {{}} Cv_Settings_Emoji_ShortInputs */
/** @typedef {{}} Cv_SpaceInputs */
/** @typedef {{}} Cv_Space_MissingInputs */
/** @typedef {{}} Cv_Space_OverviewInputs */
/** @typedef {{}} Cv_Start_HereInputs */
/** @typedef {{}} Cv_Suggest_EmojiInputs */
/** @typedef {{}} Cv_Suggest_LinksInputs */
/** @typedef {{}} Cv_Suggest_PeopleInputs */
/** @typedef {{ max: NonNullable<unknown> }} Cv_Too_LongInputs */
/** @typedef {{}} Cv_TopicInputs */
/** @typedef {{}} Cv_Topic_MenuInputs */
/** @typedef {{}} Cv_Topic_NameInputs */
/** @typedef {{}} Cv_Topic_Name_PlaceholderInputs */
/** @typedef {{}} Cv_TopicsInputs */
/** @typedef {{}} Cv_Topics_EmptyInputs */
/** @typedef {{}} Cv_Topics_None_MatchInputs */
/** @typedef {{}} Cv_Topics_StartInputs */
/** @typedef {{}} Cv_UnpinInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cv_Unpin_LabelInputs */
/** @typedef {{}} Cv_Unread_DotInputs */
/** @typedef {{}} Desktop_Client_Not_AllowedInputs */
/** @typedef {{}} Desktop_Scope_MissingInputs */
/** @typedef {{}} Desktop_Token_ExpiredInputs */
/** @typedef {{}} Desktop_Token_InvalidInputs */
/** @typedef {{}} Desktop_Token_MissingInputs */
/** @typedef {{}} Desktop_Token_RevokedInputs */
/** @typedef {{}} Desktop_WaitlistedInputs */
/** @typedef {{}} Issues_ActivityInputs */
/** @typedef {{}} Issues_Activity_Assignee_ClearInputs */
/** @typedef {{ to: NonNullable<unknown> }} Issues_Activity_Assignee_SetInputs */
/** @typedef {{}} Issues_Activity_CreatedInputs */
/** @typedef {{}} Issues_Activity_Cycle_ClearInputs */
/** @typedef {{ to: NonNullable<unknown> }} Issues_Activity_Cycle_SetInputs */
/** @typedef {{}} Issues_Activity_Due_ClearInputs */
/** @typedef {{ to: NonNullable<unknown> }} Issues_Activity_Due_SetInputs */
/** @typedef {{ label: NonNullable<unknown> }} Issues_Activity_Label_AddedInputs */
/** @typedef {{ label: NonNullable<unknown> }} Issues_Activity_Label_RemovedInputs */
/** @typedef {{ text: NonNullable<unknown> }} Issues_Activity_LineInputs */
/** @typedef {{}} Issues_Activity_Milestone_ClearInputs */
/** @typedef {{ to: NonNullable<unknown> }} Issues_Activity_Milestone_SetInputs */
/** @typedef {{}} Issues_Activity_Project_ClearInputs */
/** @typedef {{ to: NonNullable<unknown> }} Issues_Activity_Project_SetInputs */
/** @typedef {{ to: NonNullable<unknown> }} Issues_Activity_StateInputs */
/** @typedef {{}} Issues_Activity_Team_ClearInputs */
/** @typedef {{ to: NonNullable<unknown> }} Issues_Activity_Team_SetInputs */
/** @typedef {{ to: NonNullable<unknown> }} Issues_Activity_TitleInputs */
/** @typedef {{}} Issues_Add_LabelInputs */
/** @typedef {{}} Issues_Ai_MemoInputs */
/** @typedef {{}} Issues_AllInputs */
/** @typedef {{}} Issues_CancelInputs */
/** @typedef {{}} Issues_Cannot_UndoInputs */
/** @typedef {{}} Issues_Change_AssigneeInputs */
/** @typedef {{}} Issues_Change_CycleInputs */
/** @typedef {{}} Issues_Change_DueInputs */
/** @typedef {{}} Issues_Change_MilestoneInputs */
/** @typedef {{}} Issues_Change_ProjectInputs */
/** @typedef {{}} Issues_Change_SpaceInputs */
/** @typedef {{}} Issues_Change_StateInputs */
/** @typedef {{}} Issues_Change_Target_DateInputs */
/** @typedef {{}} Issues_Change_TeamInputs */
/** @typedef {{}} Issues_Choose_MilestoneInputs */
/** @typedef {{}} Issues_Choose_Team_FirstInputs */
/** @typedef {{}} Issues_Clear_DueInputs */
/** @typedef {{}} Issues_CloseInputs */
/** @typedef {{}} Issues_Col_AssigneeInputs */
/** @typedef {{}} Issues_Col_DueInputs */
/** @typedef {{}} Issues_Col_NameInputs */
/** @typedef {{}} Issues_Col_ProjectInputs */
/** @typedef {{}} Issues_Col_SpaceInputs */
/** @typedef {{}} Issues_Col_StateInputs */
/** @typedef {{}} Issues_Col_UpdatedInputs */
/** @typedef {{}} Issues_Comment_Edit_LabelInputs */
/** @typedef {{}} Issues_Comment_FailedInputs */
/** @typedef {{}} Issues_Comment_LabelInputs */
/** @typedef {{}} Issues_Comment_MenuInputs */
/** @typedef {{}} Issues_Comment_PlaceholderInputs */
/** @typedef {{ excerpt: NonNullable<unknown> }} Issues_Comment_Remove_TitleInputs */
/** @typedef {{}} Issues_CommentsInputs */
/** @typedef {{}} Issues_CreateInputs */
/** @typedef {{}} Issues_Create_FailedInputs */
/** @typedef {{}} Issues_Create_HintInputs */
/** @typedef {{}} Issues_Cycle_Active_TagInputs */
/** @typedef {{}} Issues_Cycle_Add_NextInputs */
/** @typedef {{ n: NonNullable<unknown> }} Issues_Cycle_Days_LeftInputs */
/** @typedef {{}} Issues_Cycle_Done_TagInputs */
/** @typedef {{}} Issues_Cycle_EmptyInputs */
/** @typedef {{}} Issues_Cycle_LengthInputs */
/** @typedef {{}} Issues_Cycle_MenuInputs */
/** @typedef {{ left: NonNullable<unknown> }} Issues_Cycle_Meta_ActiveInputs */
/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown> }} Issues_Cycle_Meta_DoneInputs */
/** @typedef {{ starts: NonNullable<unknown> }} Issues_Cycle_Meta_Not_StartedInputs */
/** @typedef {{}} Issues_Cycle_Not_FoundInputs */
/** @typedef {{}} Issues_Cycle_Planned_TagInputs */
/** @typedef {{}} Issues_Cycle_RemoveInputs */
/** @typedef {{}} Issues_Cycle_Remove_ActionInputs */
/** @typedef {{}} Issues_Cycle_Remove_BodyInputs */
/** @typedef {{ name: NonNullable<unknown>, team: NonNullable<unknown> }} Issues_Cycle_Remove_TitleInputs */
/** @typedef {{ starts: NonNullable<unknown>, pct: NonNullable<unknown>, count: NonNullable<unknown> }} Issues_Cycle_SubInputs */
/** @typedef {{ starts: NonNullable<unknown>, count: NonNullable<unknown> }} Issues_Cycle_Sub_PlannedInputs */
/** @typedef {{}} Issues_Cycles_EmptyInputs */
/** @typedef {{}} Issues_Cycles_None_MatchInputs */
/** @typedef {{}} Issues_Days_UnitInputs */
/** @typedef {{}} Issues_EditInputs */
/** @typedef {{}} Issues_EmptyInputs */
/** @typedef {{}} Issues_End_DateInputs */
/** @typedef {{}} Issues_Filter_SpaceInputs */
/** @typedef {{}} Issues_Filter_Space_AllInputs */
/** @typedef {{}} Issues_Filter_TeamInputs */
/** @typedef {{}} Issues_Former_MemberInputs */
/** @typedef {{}} Issues_Group_ByInputs */
/** @typedef {{}} Issues_Group_By_AssigneeInputs */
/** @typedef {{}} Issues_Group_By_ProjectInputs */
/** @typedef {{}} Issues_Group_By_StateInputs */
/** @typedef {{}} Issues_Group_By_TeamInputs */
/** @typedef {{}} Issues_Group_No_ProjectInputs */
/** @typedef {{}} Issues_Group_No_TeamInputs */
/** @typedef {{}} Issues_Load_FailedInputs */
/** @typedef {{}} Issues_Make_FirstInputs */
/** @typedef {{}} Issues_Make_ProjectInputs */
/** @typedef {{}} Issues_Make_TeamInputs */
/** @typedef {{}} Issues_MenuInputs */
/** @typedef {{}} Issues_Milestone_AddInputs */
/** @typedef {{}} Issues_Milestone_Add_RowInputs */
/** @typedef {{}} Issues_Milestone_NameInputs */
/** @typedef {{}} Issues_Milestone_Name_ExampleInputs */
/** @typedef {{}} Issues_Milestone_New_NameInputs */
/** @typedef {{ name: NonNullable<unknown> }} Issues_Milestone_RemoveInputs */
/** @typedef {{}} Issues_Milestone_Remove_BodyInputs */
/** @typedef {{}} Issues_Milestone_Remove_RowInputs */
/** @typedef {{ name: NonNullable<unknown> }} Issues_Milestone_Remove_TitleInputs */
/** @typedef {{ name: NonNullable<unknown> }} Issues_Milestone_RenameInputs */
/** @typedef {{}} Issues_Milestone_Row_PlaceholderInputs */
/** @typedef {{}} Issues_NarrowInputs */
/** @typedef {{}} Issues_Narrow_CyclesInputs */
/** @typedef {{}} Issues_Narrow_Cycles_PlaceholderInputs */
/** @typedef {{}} Issues_Narrow_PlaceholderInputs */
/** @typedef {{}} Issues_Narrow_ProjectsInputs */
/** @typedef {{}} Issues_Narrow_Projects_PlaceholderInputs */
/** @typedef {{}} Issues_NavInputs */
/** @typedef {{}} Issues_NewInputs */
/** @typedef {{}} Issues_New_ProjectInputs */
/** @typedef {{}} Issues_New_TeamInputs */
/** @typedef {{}} Issues_New_Team_Cycle_DaysInputs */
/** @typedef {{}} Issues_New_Team_Name_PlaceholderInputs */
/** @typedef {{}} Issues_New_Team_NoteInputs */
/** @typedef {{}} Issues_No_ActivityInputs */
/** @typedef {{}} Issues_No_CycleInputs */
/** @typedef {{}} Issues_No_DueInputs */
/** @typedef {{}} Issues_No_MilestoneInputs */
/** @typedef {{}} Issues_No_PermissionInputs */
/** @typedef {{}} Issues_No_Permission_ProjectInputs */
/** @typedef {{}} Issues_No_Permission_TeamInputs */
/** @typedef {{}} Issues_No_ProjectInputs */
/** @typedef {{}} Issues_No_SpaceInputs */
/** @typedef {{}} Issues_No_Space_ProjectInputs */
/** @typedef {{}} Issues_No_Space_TeamInputs */
/** @typedef {{}} Issues_No_TeamInputs */
/** @typedef {{}} Issues_NoneInputs */
/** @typedef {{}} Issues_None_MatchInputs */
/** @typedef {{}} Issues_Not_FoundInputs */
/** @typedef {{}} Issues_Not_SetInputs */
/** @typedef {{}} Issues_NoteInputs */
/** @typedef {{}} Issues_Note_New_PlaceholderInputs */
/** @typedef {{}} Issues_Note_PlaceholderInputs */
/** @typedef {{ done: NonNullable<unknown>, total: NonNullable<unknown> }} Issues_Progress_DoneInputs */
/** @typedef {{}} Issues_Project_CreateInputs */
/** @typedef {{}} Issues_Project_Create_FailedInputs */
/** @typedef {{}} Issues_Project_DoneInputs */
/** @typedef {{ count: NonNullable<unknown> }} Issues_Project_Issue_CountInputs */
/** @typedef {{}} Issues_Project_MenuInputs */
/** @typedef {{}} Issues_Project_NameInputs */
/** @typedef {{}} Issues_Project_Name_PlaceholderInputs */
/** @typedef {{}} Issues_Project_Not_FoundInputs */
/** @typedef {{}} Issues_Project_Note_New_PlaceholderInputs */
/** @typedef {{}} Issues_Project_Note_PlaceholderInputs */
/** @typedef {{ pct: NonNullable<unknown> }} Issues_Project_Pct_TargetInputs */
/** @typedef {{}} Issues_Project_Remove_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Issues_Project_Remove_TitleInputs */
/** @typedef {{}} Issues_Project_ReopenInputs */
/** @typedef {{ pct: NonNullable<unknown>, due: NonNullable<unknown>, teams: NonNullable<unknown> }} Issues_Project_SubInputs */
/** @typedef {{ pct: NonNullable<unknown>, due: NonNullable<unknown>, count: NonNullable<unknown> }} Issues_Project_SummaryInputs */
/** @typedef {{}} Issues_Projects_EmptyInputs */
/** @typedef {{}} Issues_Projects_None_DoneInputs */
/** @typedef {{}} Issues_Projects_None_MatchInputs */
/** @typedef {{}} Issues_Projects_StateInputs */
/** @typedef {{}} Issues_Prop_AssigneeInputs */
/** @typedef {{}} Issues_Prop_CycleInputs */
/** @typedef {{}} Issues_Prop_DueInputs */
/** @typedef {{}} Issues_Prop_LabelsInputs */
/** @typedef {{}} Issues_Prop_MilestoneInputs */
/** @typedef {{}} Issues_Prop_ProjectInputs */
/** @typedef {{}} Issues_Prop_StateInputs */
/** @typedef {{}} Issues_Prop_TeamInputs */
/** @typedef {{}} Issues_Range_SepInputs */
/** @typedef {{}} Issues_ReloadInputs */
/** @typedef {{}} Issues_Reload_NeededInputs */
/** @typedef {{}} Issues_RemoveInputs */
/** @typedef {{}} Issues_Remove_BodyInputs */
/** @typedef {{ names: NonNullable<unknown> }} Issues_Remove_Many_BodyInputs */
/** @typedef {{ count: NonNullable<unknown> }} Issues_Remove_Many_TitleInputs */
/** @typedef {{ title: NonNullable<unknown> }} Issues_Remove_TitleInputs */
/** @typedef {{ title: NonNullable<unknown> }} Issues_Row_MenuInputs */
/** @typedef {{}} Issues_SaveInputs */
/** @typedef {{}} Issues_Save_FailedInputs */
/** @typedef {{ state: NonNullable<unknown> }} Issues_Set_StateInputs */
/** @typedef {{}} Issues_SomeoneInputs */
/** @typedef {{}} Issues_Start_DateInputs */
/** @typedef {{ date: NonNullable<unknown> }} Issues_Starts_OnInputs */
/** @typedef {{}} Issues_State_DoingInputs */
/** @typedef {{}} Issues_State_DoneInputs */
/** @typedef {{}} Issues_State_OpenInputs */
/** @typedef {{}} Issues_State_ReviewInputs */
/** @typedef {{}} Issues_Tab_CyclesInputs */
/** @typedef {{}} Issues_Tab_IssuesInputs */
/** @typedef {{}} Issues_Tab_ProjectsInputs */
/** @typedef {{}} Issues_Tab_UpcomingInputs */
/** @typedef {{}} Issues_TabsInputs */
/** @typedef {{}} Issues_Target_DateInputs */
/** @typedef {{}} Issues_Team_CreateInputs */
/** @typedef {{}} Issues_Team_Create_FailedInputs */
/** @typedef {{}} Issues_Team_NameInputs */
/** @typedef {{}} Issues_Team_SettingsInputs */
/** @typedef {{}} Issues_Teams_EmptyInputs */
/** @typedef {{ n: NonNullable<unknown> }} Issues_Time_Days_AgoInputs */
/** @typedef {{ time: NonNullable<unknown> }} Issues_Time_YesterdayInputs */
/** @typedef {{}} Issues_Title_LabelInputs */
/** @typedef {{}} Issues_Title_PlaceholderInputs */
/** @typedef {{ max: NonNullable<unknown> }} Issues_Too_LongInputs */
/** @typedef {{}} Issues_UnassignedInputs */
/** @typedef {{}} Issues_Upcoming_EmptyInputs */
/** @typedef {{}} Mail_Approved_Line_BodyInputs */
/** @typedef {{}} Mail_Approved_SubjectInputs */
/** @typedef {{ otp: NonNullable<unknown> }} Mail_Sign_In_Code_Line_CodeInputs */
/** @typedef {{ minutes: NonNullable<unknown> }} Mail_Sign_In_Code_Line_ExpiresInputs */
/** @typedef {{}} Mail_Sign_In_Code_Line_IgnoreInputs */
/** @typedef {{}} Mail_Sign_In_Code_SubjectInputs */
/** @typedef {{ email: NonNullable<unknown> }} Mail_Waitlist_Joined_Line_BodyInputs */
/** @typedef {{}} Mail_Waitlist_Joined_SubjectInputs */
/** @typedef {{}} Publish_ArchivedInputs */
/** @typedef {{}} Publish_Kind_ChatInputs */
/** @typedef {{}} Publish_Kind_MemberInputs */
/** @typedef {{}} Publish_Kind_MessageInputs */
/** @typedef {{}} Publish_Kind_OtherInputs */
/** @typedef {{}} Publish_Kind_Private_PageInputs */
/** @typedef {{}} Publish_Made_WithInputs */
/** @typedef {{}} Publish_Slide_ControlsInputs */
/** @typedef {{}} Publish_Slide_Exit_FullscreenInputs */
/** @typedef {{}} Publish_Slide_FullscreenInputs */
/** @typedef {{}} Publish_Slide_NextInputs */
/** @typedef {{}} Publish_Slide_PrevInputs */
/** @typedef {{}} Publish_UnavailableInputs */
/** @typedef {{ date: NonNullable<unknown> }} Publish_Updated_AtInputs */
/** @typedef {{ device: NonNullable<unknown> }} Push_App_DeniedInputs */
/** @typedef {{ device: NonNullable<unknown> }} Push_App_LabelInputs */
/** @typedef {{}} Push_App_Open_SettingsInputs */
/** @typedef {{}} Push_BlockedInputs */
/** @typedef {{ when: NonNullable<unknown> }} Push_Delivered_AtInputs */
/** @typedef {{}} Push_Desktop_AppInputs */
/** @typedef {{}} Push_Desktop_BlockedInputs */
/** @typedef {{}} Push_Desktop_Open_SettingsInputs */
/** @typedef {{}} Push_Desktop_UnsignedInputs */
/** @typedef {{}} Push_DestinationsInputs */
/** @typedef {{}} Push_Hub_SealedInputs */
/** @typedef {{}} Push_Ios_Add_To_HomeInputs */
/** @typedef {{}} Push_Not_DeliveredInputs */
/** @typedef {{}} Push_Not_SentInputs */
/** @typedef {{}} Push_Other_DeviceInputs */
/** @typedef {{}} Push_ReceiveInputs */
/** @typedef {{}} Push_RemoveInputs */
/** @typedef {{ name: NonNullable<unknown> }} Push_Remove_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Push_RemovedInputs */
/** @typedef {{}} Push_Send_TestInputs */
/** @typedef {{}} Push_SentInputs */
/** @typedef {{}} Push_Subscribe_FailedInputs */
/** @typedef {{}} Push_Test_FailedInputs */
/** @typedef {{}} Push_This_DeviceInputs */
/** @typedef {{}} Push_UnavailableInputs */
/** @typedef {{}} Push_Unsubscribe_FailedInputs */
/** @typedef {{}} Push_UnsupportedInputs */
/** @typedef {{}} Sandboxes_Admin_AllowInputs */
/** @typedef {{}} Sandboxes_Admin_Allow_By_EmailInputs */
/** @typedef {{}} Sandboxes_Admin_Allow_By_Email_NoteInputs */
/** @typedef {{}} Sandboxes_Admin_Allow_DevInputs */
/** @typedef {{}} Sandboxes_Admin_Allow_FailedInputs */
/** @typedef {{}} Sandboxes_Admin_Col_AllowedInputs */
/** @typedef {{}} Sandboxes_Admin_Col_EmailInputs */
/** @typedef {{}} Sandboxes_Admin_Col_KindInputs */
/** @typedef {{}} Sandboxes_Admin_Col_StateInputs */
/** @typedef {{}} Sandboxes_Admin_DescriptionInputs */
/** @typedef {{}} Sandboxes_Admin_Email_LabelInputs */
/** @typedef {{}} Sandboxes_Admin_EmptyInputs */
/** @typedef {{}} Sandboxes_Admin_Kind_DevInputs */
/** @typedef {{}} Sandboxes_Admin_Kind_GeneralInputs */
/** @typedef {{ time: NonNullable<unknown> }} Sandboxes_Admin_Last_ActiveInputs */
/** @typedef {{}} Sandboxes_Admin_Memory_NoteInputs */
/** @typedef {{ used: NonNullable<unknown>, budget: NonNullable<unknown> }} Sandboxes_Admin_Memory_UsageInputs */
/** @typedef {{}} Sandboxes_Admin_Not_CreatedInputs */
/** @typedef {{}} Sandboxes_Admin_RevokeInputs */
/** @typedef {{ label: NonNullable<unknown> }} Sandboxes_Admin_Revoke_Confirm_DevInputs */
/** @typedef {{ label: NonNullable<unknown> }} Sandboxes_Admin_Revoke_Confirm_GeneralInputs */
/** @typedef {{ email: NonNullable<unknown> }} Sandboxes_Admin_Revoke_Failed_DevInputs */
/** @typedef {{ email: NonNullable<unknown> }} Sandboxes_Admin_Revoke_Failed_GeneralInputs */
/** @typedef {{ email: NonNullable<unknown> }} Sandboxes_Admin_Revoke_Label_DevInputs */
/** @typedef {{ email: NonNullable<unknown> }} Sandboxes_Admin_Revoke_Label_GeneralInputs */
/** @typedef {{ state: NonNullable<unknown> }} Sandboxes_Admin_Revoking_StateInputs */
/** @typedef {{}} Sandboxes_Admin_TitleInputs */
/** @typedef {{}} Sandboxes_Error_CollisionInputs */
/** @typedef {{ minutes: NonNullable<unknown> }} Sandboxes_Error_Delete_TimeoutInputs */
/** @typedef {{}} Sandboxes_Error_K8sInputs */
/** @typedef {{}} Sandboxes_Error_No_Dev_ImageInputs */
/** @typedef {{ code: NonNullable<unknown> }} Sandboxes_Error_OtherInputs */
/** @typedef {{}} Sandboxes_Error_Profile_MismatchInputs */
/** @typedef {{ minutes: NonNullable<unknown> }} Sandboxes_Error_Start_TimeoutInputs */
/** @typedef {{ minutes: NonNullable<unknown> }} Sandboxes_Error_Stop_TimeoutInputs */
/** @typedef {{ minutes: NonNullable<unknown> }} Sandboxes_Error_UnreachableInputs */
/** @typedef {{ name: NonNullable<unknown> }} Sandboxes_Line_AsleepInputs */
/** @typedef {{ name: NonNullable<unknown> }} Sandboxes_Line_DeletingInputs */
/** @typedef {{ name: NonNullable<unknown>, error: NonNullable<unknown> }} Sandboxes_Line_ErrorInputs */
/** @typedef {{ name: NonNullable<unknown> }} Sandboxes_Line_PreparingInputs */
/** @typedef {{ name: NonNullable<unknown>, n: NonNullable<unknown> }} Sandboxes_Line_QueuedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Sandboxes_Line_WakingInputs */
/** @typedef {{}} Sandboxes_Menu_PreviewsInputs */
/** @typedef {{}} Sandboxes_Name_DevInputs */
/** @typedef {{}} Sandboxes_Name_GeneralInputs */
/** @typedef {{}} Sandboxes_Preview_ForbiddenInputs */
/** @typedef {{}} Sandboxes_Preview_Open_FailedInputs */
/** @typedef {{}} Sandboxes_Preview_OpeningInputs */
/** @typedef {{}} Sandboxes_Previews_DescriptionInputs */
/** @typedef {{}} Sandboxes_Previews_EmptyInputs */
/** @typedef {{ time: NonNullable<unknown> }} Sandboxes_Previews_Last_SeenInputs */
/** @typedef {{}} Sandboxes_Previews_None_RunningInputs */
/** @typedef {{}} Sandboxes_Previews_Status_ConflictInputs */
/** @typedef {{}} Sandboxes_Previews_Status_FailedInputs */
/** @typedef {{}} Sandboxes_Previews_Status_MissingInputs */
/** @typedef {{}} Sandboxes_Previews_Status_RunningInputs */
/** @typedef {{}} Sandboxes_Previews_StopInputs */
/** @typedef {{ name: NonNullable<unknown> }} Sandboxes_Previews_Stop_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Sandboxes_Previews_Stop_LabelInputs */
/** @typedef {{ name: NonNullable<unknown> }} Sandboxes_Previews_Stop_OfflineInputs */
/** @typedef {{}} Sandboxes_Previews_StoppingInputs */
/** @typedef {{}} Sandboxes_Previews_TitleInputs */
/** @typedef {{}} Sandboxes_Status_AsleepInputs */
/** @typedef {{}} Sandboxes_Status_DeletingInputs */
/** @typedef {{}} Sandboxes_Status_ErrorInputs */
/** @typedef {{}} Sandboxes_Status_PreparingInputs */
/** @typedef {{}} Sandboxes_Status_QueuedInputs */
/** @typedef {{ n: NonNullable<unknown> }} Sandboxes_Status_Queued_AtInputs */
/** @typedef {{}} Sandboxes_Status_RunningInputs */
/** @typedef {{}} Sandboxes_Status_WakingInputs */
/** @typedef {{}} Vc_CallsInputs */
/** @typedef {{}} Vc_CancelInputs */
/** @typedef {{}} Vc_Close_DisabledInputs */
/** @typedef {{}} Vc_Close_EndedInputs */
/** @typedef {{}} Vc_Close_FullInputs */
/** @typedef {{}} Vc_Close_Not_FoundInputs */
/** @typedef {{}} Vc_Close_ReplacedInputs */
/** @typedef {{}} Vc_Closed_RejoinInputs */
/** @typedef {{}} Vc_Conn_ClosedInputs */
/** @typedef {{}} Vc_Conn_ConnectedInputs */
/** @typedef {{}} Vc_Conn_ConnectingInputs */
/** @typedef {{}} Vc_Conn_FailedInputs */
/** @typedef {{}} Vc_Conn_UnstableInputs */
/** @typedef {{}} Vc_Denoise_LoadingInputs */
/** @typedef {{}} Vc_Denoise_OffInputs */
/** @typedef {{}} Vc_Denoise_OnInputs */
/** @typedef {{}} Vc_Denoise_UnavailableInputs */
/** @typedef {{ elapsed: NonNullable<unknown> }} Vc_ElapsedInputs */
/** @typedef {{}} Vc_EmptyInputs */
/** @typedef {{}} Vc_EndInputs */
/** @typedef {{}} Vc_End_FailedInputs */
/** @typedef {{}} Vc_Ended_MarkInputs */
/** @typedef {{ when: NonNullable<unknown>, duration: NonNullable<unknown>, people: NonNullable<unknown> }} Vc_Ended_SubInputs */
/** @typedef {{}} Vc_FilterInputs */
/** @typedef {{}} Vc_Filter_AllInputs */
/** @typedef {{}} Vc_Filter_EndedInputs */
/** @typedef {{}} Vc_Filter_LiveInputs */
/** @typedef {{}} Vc_JoinInputs */
/** @typedef {{}} Vc_Join_Prepare_FailedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Vc_Joined_AriaInputs */
/** @typedef {{}} Vc_LeaveInputs */
/** @typedef {{}} Vc_Live_MarkInputs */
/** @typedef {{}} Vc_Load_FailedInputs */
/** @typedef {{}} Vc_Mic_DeniedInputs */
/** @typedef {{ min: NonNullable<unknown> }} Vc_MinutesInputs */
/** @typedef {{}} Vc_MuteInputs */
/** @typedef {{}} Vc_MutedInputs */
/** @typedef {{}} Vc_NarrowInputs */
/** @typedef {{}} Vc_Narrow_TitleInputs */
/** @typedef {{}} Vc_New_CallInputs */
/** @typedef {{}} Vc_New_NoteInputs */
/** @typedef {{}} Vc_No_SpaceInputs */
/** @typedef {{}} Vc_NobodyInputs */
/** @typedef {{}} Vc_None_MatchInputs */
/** @typedef {{}} Vc_Not_FoundInputs */
/** @typedef {{}} Vc_Note_EndedInputs */
/** @typedef {{}} Vc_Note_LiveInputs */
/** @typedef {{}} Vc_Own_ScreenInputs */
/** @typedef {{ count: NonNullable<unknown> }} Vc_PeopleInputs */
/** @typedef {{}} Vc_Play_AudioInputs */
/** @typedef {{}} Vc_ReconnectingInputs */
/** @typedef {{ name: NonNullable<unknown> }} Vc_Screen_OfInputs */
/** @typedef {{}} Vc_Self_SuffixInputs */
/** @typedef {{}} Vc_Share_ScreenInputs */
/** @typedef {{}} Vc_SharingInputs */
/** @typedef {{}} Vc_Space_LabelInputs */
/** @typedef {{}} Vc_StartInputs */
/** @typedef {{}} Vc_Start_FailedInputs */
/** @typedef {{}} Vc_Stop_SharingInputs */
/** @typedef {{}} Vc_Title_AriaInputs */
/** @typedef {{}} Vc_Title_LabelInputs */
/** @typedef {{}} Vc_Title_PlaceholderInputs */
/** @typedef {{}} Vc_To_ListInputs */
/** @typedef {{}} Vc_Unknown_MemberInputs */
/** @typedef {{}} Vc_UnmuteInputs */
/** @typedef {{}} Vc_Waiting_VideoInputs */
/** @typedef {{}} Wd_Col_SpaceInputs */
/** @typedef {{}} Wd_DatasetsInputs */
/** @typedef {{}} Wd_Datasets_BackInputs */
/** @typedef {{}} Wd_Datasets_CreateInputs */
/** @typedef {{}} Wd_Datasets_Create_FailedInputs */
/** @typedef {{}} Wd_Datasets_EmptyInputs */
/** @typedef {{}} Wd_Datasets_Load_FailedInputs */
/** @typedef {{}} Wd_Datasets_NewInputs */
/** @typedef {{}} Wd_Datasets_New_NoteInputs */
/** @typedef {{}} Wd_Datasets_None_MatchInputs */
/** @typedef {{ count: NonNullable<unknown> }} Wd_Datasets_RowsInputs */
/** @typedef {{}} Wd_Datasets_SpaceInputs */
/** @typedef {{}} Wd_Datasets_Space_EmptyInputs */
/** @typedef {{}} Wd_Datasets_TitleInputs */
/** @typedef {{}} Wd_EmptyInputs */
/** @typedef {{}} Wd_Load_FailedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Wd_Move_FailedInputs */
/** @typedef {{}} Wd_Move_HintInputs */
/** @typedef {{ title: NonNullable<unknown> }} Wd_Move_TitleInputs */
/** @typedef {{}} Wd_NavInputs */
/** @typedef {{}} Wd_New_InInputs */
/** @typedef {{}} Wd_No_SpaceInputs */
/** @typedef {{}} Wd_None_MatchInputs */
/** @typedef {{ title: NonNullable<unknown> }} Wd_Pin_FailedInputs */
/** @typedef {{}} Wd_ReleaseInputs */
/** @typedef {{}} Wd_Release_ActionInputs */
/** @typedef {{}} Wd_Release_BodyInputs */
/** @typedef {{ title: NonNullable<unknown> }} Wd_Release_FailedInputs */
/** @typedef {{}} Wd_Release_No_SpaceInputs */
/** @typedef {{}} Wd_Release_NoneInputs */
/** @typedef {{}} Wd_Release_SpaceInputs */
/** @typedef {{ title: NonNullable<unknown> }} Wd_Release_TitleInputs */
/** @typedef {{}} Wd_Release_WorkspaceInputs */
/** @typedef {{ title: NonNullable<unknown>, workspace: NonNullable<unknown> }} Wd_ReleasedInputs */
/** @typedef {{}} Wd_Space_EmptyInputs */
/** @typedef {{}} Web_Admin_DescriptionInputs */
/** @typedef {{}} Web_Admin_TitleInputs */
/** @typedef {{}} Web_Admin_Waitlist_ApproveInputs */
/** @typedef {{}} Web_Admin_Waitlist_Approve_FailedInputs */
/** @typedef {{ count: NonNullable<unknown> }} Web_Admin_Waitlist_Approved_DoneInputs */
/** @typedef {{}} Web_Admin_Waitlist_ClearInputs */
/** @typedef {{}} Web_Admin_Waitlist_Col_EmailInputs */
/** @typedef {{}} Web_Admin_Waitlist_Col_JoinedInputs */
/** @typedef {{}} Web_Admin_Waitlist_Col_ViaInputs */
/** @typedef {{}} Web_Admin_Waitlist_Confirm_ApproveInputs */
/** @typedef {{ count: NonNullable<unknown> }} Web_Admin_Waitlist_Confirm_TextInputs */
/** @typedef {{}} Web_Admin_Waitlist_DescriptionInputs */
/** @typedef {{}} Web_Admin_Waitlist_EmptyInputs */
/** @typedef {{}} Web_Admin_Waitlist_Select_AllInputs */
/** @typedef {{ count: NonNullable<unknown> }} Web_Admin_Waitlist_SelectedInputs */
/** @typedef {{}} Web_Admin_Waitlist_TitleInputs */
/** @typedef {{}} Web_Admin_Waitlist_ToolbarInputs */
/** @typedef {{}} Web_Admin_Waitlist_Via_EmailInputs */
/** @typedef {{}} Web_App_Update_LoadInputs */
/** @typedef {{}} Web_BannedInputs */
/** @typedef {{}} Web_Captcha_FailedInputs */
/** @typedef {{}} Web_Home_IconInputs */
/** @typedef {{}} Web_Home_Icon_BlackInputs */
/** @typedef {{}} Web_Home_Icon_GreenInputs */
/** @typedef {{}} Web_Home_Icon_Ground_BlackInputs */
/** @typedef {{}} Web_Home_Icon_Ground_WhiteInputs */
/** @typedef {{}} Web_Home_Icon_InkInputs */
/** @typedef {{}} Web_Home_Icon_NoteInputs */
/** @typedef {{}} Web_Home_Icon_PurpleInputs */
/** @typedef {{}} Web_Home_Icon_StandardInputs */
/** @typedef {{}} Web_Home_Icon_VermilionInputs */
/** @typedef {{}} Web_Home_Icon_WhiteInputs */
/** @typedef {{}} Web_Hub_AllowInputs */
/** @typedef {{}} Web_Hub_Code_LabelInputs */
/** @typedef {{}} Web_Hub_Code_NextInputs */
/** @typedef {{ name: NonNullable<unknown> }} Web_Hub_ConnectingInputs */
/** @typedef {{}} Web_Hub_DeniedInputs */
/** @typedef {{}} Web_Hub_DenyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Web_Hub_Desktop_ConnectingInputs */
/** @typedef {{}} Web_Hub_Desktop_DeniedInputs */
/** @typedef {{}} Web_Hub_Desktop_DoneInputs */
/** @typedef {{}} Web_Hub_Desktop_WhatInputs */
/** @typedef {{}} Web_Hub_DoneInputs */
/** @typedef {{}} Web_Hub_FailedInputs */
/** @typedef {{}} Web_Hub_Not_FoundInputs */
/** @typedef {{}} Web_Hub_Pair_PcInputs */
/** @typedef {{}} Web_Hub_Pair_PhoneInputs */
/** @typedef {{}} Web_Hub_Pair_TitleInputs */
/** @typedef {{ time: NonNullable<unknown> }} Web_Hub_Started_AtInputs */
/** @typedef {{ place: NonNullable<unknown> }} Web_Hub_Started_FromInputs */
/** @typedef {{}} Web_Hub_TitleInputs */
/** @typedef {{}} Web_Hub_Type_CodeInputs */
/** @typedef {{}} Web_Hub_WarningInputs */
/** @typedef {{}} Web_Hub_WhatInputs */
/** @typedef {{}} Web_Load_FailedInputs */
/** @typedef {{}} Web_Mail_FailedInputs */
/** @typedef {{}} Web_Me_Moving_BodyInputs */
/** @typedef {{}} Web_Me_Moving_Open_HereInputs */
/** @typedef {{}} Web_Me_Moving_TitleInputs */
/** @typedef {{ hub: NonNullable<unknown> }} Web_Me_On_Hub_BodyInputs */
/** @typedef {{}} Web_Me_On_Hub_Body_UnnamedInputs */
/** @typedef {{}} Web_Me_On_Hub_TitleInputs */
/** @typedef {{}} Web_Me_Opening_HereInputs */
/** @typedef {{}} Web_Menu_AdminInputs */
/** @typedef {{}} Web_Menu_Sign_OutInputs */
/** @typedef {{}} Web_Oauth_AllowInputs */
/** @typedef {{}} Web_Oauth_Can_DoInputs */
/** @typedef {{ client: NonNullable<unknown> }} Web_Oauth_ConnectingInputs */
/** @typedef {{}} Web_Oauth_DenyInputs */
/** @typedef {{}} Web_Oauth_Desktop_WarningInputs */
/** @typedef {{ where: NonNullable<unknown> }} Web_Oauth_DestinationInputs */
/** @typedef {{}} Web_Oauth_FailedInputs */
/** @typedef {{}} Web_Oauth_Outside_FlowInputs */
/** @typedef {{}} Web_Oauth_Scope_DesktopInputs */
/** @typedef {{}} Web_Oauth_Scope_OfflineInputs */
/** @typedef {{}} Web_Oauth_Scope_ReadInputs */
/** @typedef {{}} Web_Oauth_Scope_WriteInputs */
/** @typedef {{ where: NonNullable<unknown> }} Web_Oauth_This_DeviceInputs */
/** @typedef {{}} Web_Oauth_TitleInputs */
/** @typedef {{}} Web_Oauth_UnverifiedInputs */
/** @typedef {{}} Web_Otp_ExpiredInputs */
/** @typedef {{}} Web_Otp_InvalidInputs */
/** @typedef {{}} Web_Otp_Too_ManyInputs */
/** @typedef {{}} Web_Passkey_FailedInputs */
/** @typedef {{}} Web_Passkey_LaterInputs */
/** @typedef {{}} Web_Passkey_Later_NoteInputs */
/** @typedef {{}} Web_Passkey_LeadInputs */
/** @typedef {{}} Web_Passkey_NoneInputs */
/** @typedef {{}} Web_Passkey_RegisterInputs */
/** @typedef {{}} Web_Passkey_Register_FailedInputs */
/** @typedef {{}} Web_Passkey_TitleInputs */
/** @typedef {{}} Web_Rate_LimitedInputs */
/** @typedef {{}} Web_Resend_Too_SoonInputs */
/** @typedef {{}} Web_RetryInputs */
/** @typedef {{}} Web_Settings_AppsInputs */
/** @typedef {{ name: NonNullable<unknown> }} Web_Settings_Apps_Allow_WorkspaceInputs */
/** @typedef {{ scopes: NonNullable<unknown>, granted: NonNullable<unknown> }} Web_Settings_Apps_App_DescriptionInputs */
/** @typedef {{}} Web_Settings_Apps_CopiedInputs */
/** @typedef {{}} Web_Settings_Apps_CopyInputs */
/** @typedef {{}} Web_Settings_Apps_DescriptionInputs */
/** @typedef {{}} Web_Settings_Apps_DisconnectInputs */
/** @typedef {{}} Web_Settings_Apps_Disconnect_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Web_Settings_Apps_Disconnect_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Web_Settings_Apps_Disconnect_TitleInputs */
/** @typedef {{}} Web_Settings_Apps_EmptyInputs */
/** @typedef {{}} Web_Settings_Apps_ListInputs */
/** @typedef {{}} Web_Settings_Apps_No_WorkspacesInputs */
/** @typedef {{}} Web_Settings_Apps_Not_AllowedInputs */
/** @typedef {{}} Web_Settings_Apps_Scope_DesktopInputs */
/** @typedef {{}} Web_Settings_Apps_Scope_OfflineInputs */
/** @typedef {{}} Web_Settings_Apps_Scope_ReadInputs */
/** @typedef {{}} Web_Settings_Apps_Scope_WriteInputs */
/** @typedef {{}} Web_Settings_Apps_UrlInputs */
/** @typedef {{}} Web_Settings_Apps_Url_NoteInputs */
/** @typedef {{ name: NonNullable<unknown> }} Web_Settings_Apps_Workspace_FailedInputs */
/** @typedef {{}} Web_Settings_Apps_WorkspacesInputs */
/** @typedef {{}} Web_Settings_Apps_Workspaces_NoteInputs */
/** @typedef {{}} Web_Settings_DescriptionInputs */
/** @typedef {{}} Web_Settings_SecurityInputs */
/** @typedef {{}} Web_Settings_Security_AddInputs */
/** @typedef {{}} Web_Settings_Security_Add_FailedInputs */
/** @typedef {{}} Web_Settings_Security_Delete_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Web_Settings_Security_Delete_FailedInputs */
/** @typedef {{}} Web_Settings_Security_Delete_Last_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Web_Settings_Security_Delete_NamedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Web_Settings_Security_Delete_TitleInputs */
/** @typedef {{}} Web_Settings_Security_DescriptionInputs */
/** @typedef {{}} Web_Settings_Security_EmailInputs */
/** @typedef {{}} Web_Settings_Security_Email_NoteInputs */
/** @typedef {{}} Web_Settings_Security_GoogleInputs */
/** @typedef {{}} Web_Settings_Security_Google_LinkInputs */
/** @typedef {{}} Web_Settings_Security_Google_Link_FailedInputs */
/** @typedef {{}} Web_Settings_Security_Google_LinkedInputs */
/** @typedef {{}} Web_Settings_Security_Google_Not_ConfiguredInputs */
/** @typedef {{}} Web_Settings_Security_Google_NoteInputs */
/** @typedef {{}} Web_Settings_Security_PasskeysInputs */
/** @typedef {{}} Web_Settings_Security_Passkeys_NoteInputs */
/** @typedef {{ date: NonNullable<unknown> }} Web_Settings_Security_Registered_OnInputs */
/** @typedef {{}} Web_Settings_Security_UnnamedInputs */
/** @typedef {{}} Web_Settings_TitleInputs */
/** @typedef {{}} Web_Signin_Code_LabelInputs */
/** @typedef {{ email: NonNullable<unknown>, minutes: NonNullable<unknown> }} Web_Signin_Code_ReusedInputs */
/** @typedef {{ email: NonNullable<unknown>, minutes: NonNullable<unknown> }} Web_Signin_Code_SentInputs */
/** @typedef {{}} Web_Signin_ContinueInputs */
/** @typedef {{}} Web_Signin_Email_HintInputs */
/** @typedef {{}} Web_Signin_Email_InvalidInputs */
/** @typedef {{}} Web_Signin_Email_LabelInputs */
/** @typedef {{}} Web_Signin_FailedInputs */
/** @typedef {{}} Web_Signin_GoogleInputs */
/** @typedef {{}} Web_Signin_Google_FailedInputs */
/** @typedef {{}} Web_Signin_In_App_BodyInputs */
/** @typedef {{}} Web_Signin_In_App_TitleInputs */
/** @typedef {{}} Web_Signin_Other_EmailInputs */
/** @typedef {{}} Web_Signin_PasskeyInputs */
/** @typedef {{}} Web_Signin_ResendInputs */
/** @typedef {{}} Web_Signin_ResentInputs */
/** @typedef {{}} Web_Signin_RetryInputs */
/** @typedef {{}} Web_Signin_TitleInputs */
/** @typedef {{}} Web_Trust_Approve_PcInputs */
/** @typedef {{}} Web_Trust_Approve_PhoneInputs */
/** @typedef {{}} Web_Trust_Approve_TitleInputs */
/** @typedef {{ email: NonNullable<unknown> }} Web_Waitlist_BodyInputs */
/** @typedef {{}} Web_Waitlist_SwitchInputs */
/** @typedef {{}} Web_Waitlist_TitleInputs */
/** @typedef {{}} Workspace_Default_Role_AdminInputs */
/** @typedef {{}} Workspace_Default_Space_NameInputs */
/** @typedef {{}} Workspace_Unnamed_MemberInputs */
/** @typedef {{}} Ws_CancelInputs */
/** @typedef {{}} Ws_Case_PanelInputs */
/** @typedef {{}} Ws_DeleteInputs */
/** @typedef {{}} Ws_Dock_SpacesInputs */
/** @typedef {{}} Ws_Feature_BroadcastInputs */
/** @typedef {{}} Ws_Feature_Broadcast_NoteInputs */
/** @typedef {{}} Ws_Feature_CycleInputs */
/** @typedef {{}} Ws_Feature_Cycle_NoteInputs */
/** @typedef {{}} Ws_Feature_DmInputs */
/** @typedef {{}} Ws_Feature_Dm_NoteInputs */
/** @typedef {{}} Ws_Feature_DocumentInputs */
/** @typedef {{}} Ws_Feature_Document_NoteInputs */
/** @typedef {{}} Ws_Feature_IssueInputs */
/** @typedef {{}} Ws_Feature_Issue_NoteInputs */
/** @typedef {{}} Ws_Feature_JournalInputs */
/** @typedef {{}} Ws_Feature_Journal_NoteInputs */
/** @typedef {{}} Ws_Feature_ProjectInputs */
/** @typedef {{}} Ws_Feature_Project_NoteInputs */
/** @typedef {{ feature: NonNullable<unknown> }} Ws_Feature_RequiresInputs */
/** @typedef {{}} Ws_Feature_TopicInputs */
/** @typedef {{}} Ws_Feature_Topic_NoteInputs */
/** @typedef {{}} Ws_Feature_VoiceInputs */
/** @typedef {{}} Ws_Feature_Voice_NoteInputs */
/** @typedef {{}} Ws_Features_EnabledInputs */
/** @typedef {{}} Ws_Features_McpInputs */
/** @typedef {{}} Ws_Features_Mcp_NoteInputs */
/** @typedef {{}} Ws_Features_OutsideInputs */
/** @typedef {{}} Ws_Features_PublishInputs */
/** @typedef {{}} Ws_Features_Publish_NoteInputs */
/** @typedef {{}} Ws_Features_Publish_OffInputs */
/** @typedef {{}} Ws_Features_Publish_Off_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Features_Publish_Off_TitleInputs */
/** @typedef {{}} Ws_General_IconInputs */
/** @typedef {{}} Ws_General_Icon_NoteInputs */
/** @typedef {{}} Ws_General_NameInputs */
/** @typedef {{}} Ws_General_UrlInputs */
/** @typedef {{}} Ws_General_Url_ChangeInputs */
/** @typedef {{}} Ws_General_Url_EditInputs */
/** @typedef {{}} Ws_General_Url_Edit_TitleInputs */
/** @typedef {{}} Ws_General_Url_NoteInputs */
/** @typedef {{}} Ws_Home_EmptyInputs */
/** @typedef {{}} Ws_Invite_FailedInputs */
/** @typedef {{ kind: NonNullable<unknown> }} Ws_Invite_Guest_NoteInputs */
/** @typedef {{}} Ws_Invite_JoinInputs */
/** @typedef {{}} Ws_Invite_LoadingInputs */
/** @typedef {{}} Ws_Invite_Not_FoundInputs */
/** @typedef {{}} Ws_Invite_Sign_InInputs */
/** @typedef {{}} Ws_Invite_TitleInputs */
/** @typedef {{ workspace: NonNullable<unknown> }} Ws_Invite_ToInputs */
/** @typedef {{ workspace: NonNullable<unknown> }} Ws_Invite_UnusableInputs */
/** @typedef {{}} Ws_Invites_ActiveInputs */
/** @typedef {{}} Ws_Invites_AllInputs */
/** @typedef {{}} Ws_Invites_CopiedInputs */
/** @typedef {{}} Ws_Invites_CopyInputs */
/** @typedef {{}} Ws_Invites_Copy_FailedInputs */
/** @typedef {{}} Ws_Invites_CreateInputs */
/** @typedef {{}} Ws_Invites_Create_FailedInputs */
/** @typedef {{ count: NonNullable<unknown> }} Ws_Invites_DaysInputs */
/** @typedef {{}} Ws_Invites_EmptyInputs */
/** @typedef {{}} Ws_Invites_ExpiredInputs */
/** @typedef {{}} Ws_Invites_ExpiresInputs */
/** @typedef {{}} Ws_Invites_FilterInputs */
/** @typedef {{}} Ws_Invites_Guest_NoteInputs */
/** @typedef {{}} Ws_Invites_Joins_AsInputs */
/** @typedef {{}} Ws_Invites_KindInputs */
/** @typedef {{}} Ws_Invites_LinkInputs */
/** @typedef {{}} Ws_Invites_ListInputs */
/** @typedef {{}} Ws_Invites_Max_UsesInputs */
/** @typedef {{}} Ws_Invites_Member_NoteInputs */
/** @typedef {{}} Ws_Invites_NeverInputs */
/** @typedef {{}} Ws_Invites_NewInputs */
/** @typedef {{}} Ws_Invites_No_ActiveInputs */
/** @typedef {{}} Ws_Invites_Not_FoundInputs */
/** @typedef {{}} Ws_Invites_RevokeInputs */
/** @typedef {{}} Ws_Invites_Revoke_FailedInputs */
/** @typedef {{}} Ws_Invites_Revoke_NoteInputs */
/** @typedef {{}} Ws_Invites_RevokedInputs */
/** @typedef {{}} Ws_Invites_RoleInputs */
/** @typedef {{}} Ws_Invites_Role_NoteInputs */
/** @typedef {{ count: NonNullable<unknown> }} Ws_Invites_TimesInputs */
/** @typedef {{}} Ws_Invites_UnlimitedInputs */
/** @typedef {{ date: NonNullable<unknown> }} Ws_Invites_UntilInputs */
/** @typedef {{}} Ws_Invites_UrlInputs */
/** @typedef {{}} Ws_Invites_Url_HiddenInputs */
/** @typedef {{}} Ws_Invites_Url_NoteInputs */
/** @typedef {{ used: NonNullable<unknown>, max: NonNullable<unknown> }} Ws_Invites_UsageInputs */
/** @typedef {{ used: NonNullable<unknown> }} Ws_Invites_Usage_UnlimitedInputs */
/** @typedef {{}} Ws_Invites_Used_UpInputs */
/** @typedef {{}} Ws_Invites_UsesInputs */
/** @typedef {{ used: NonNullable<unknown>, max: NonNullable<unknown> }} Ws_Invites_Uses_OfInputs */
/** @typedef {{ used: NonNullable<unknown> }} Ws_Invites_Uses_UnlimitedInputs */
/** @typedef {{}} Ws_Invites_ValidInputs */
/** @typedef {{}} Ws_Kind_GuestInputs */
/** @typedef {{}} Ws_Kind_MemberInputs */
/** @typedef {{}} Ws_List_NarrowInputs */
/** @typedef {{}} Ws_List_Narrow_NameInputs */
/** @typedef {{}} Ws_List_No_MatchInputs */
/** @typedef {{}} Ws_Load_FailedInputs */
/** @typedef {{}} Ws_Members_AllInputs */
/** @typedef {{}} Ws_Members_BulkInputs */
/** @typedef {{}} Ws_Members_Bulk_ClearInputs */
/** @typedef {{ count: NonNullable<unknown> }} Ws_Members_Bulk_Remove_FailedInputs */
/** @typedef {{ count: NonNullable<unknown> }} Ws_Members_Bulk_Remove_TitleInputs */
/** @typedef {{}} Ws_Members_Col_JoinedInputs */
/** @typedef {{}} Ws_Members_Col_KindInputs */
/** @typedef {{}} Ws_Members_Col_Last_ActiveInputs */
/** @typedef {{}} Ws_Members_Col_NameInputs */
/** @typedef {{}} Ws_Members_Col_RegisteredInputs */
/** @typedef {{}} Ws_Members_Col_RolesInputs */
/** @typedef {{}} Ws_Members_EmptyInputs */
/** @typedef {{}} Ws_Members_FilterInputs */
/** @typedef {{}} Ws_Members_Guest_No_RolesInputs */
/** @typedef {{ date: NonNullable<unknown> }} Ws_Members_JoinedInputs */
/** @typedef {{}} Ws_Members_KindInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Members_Kind_FailedInputs */
/** @typedef {{}} Ws_Members_ListInputs */
/** @typedef {{}} Ws_Members_Make_GuestInputs */
/** @typedef {{}} Ws_Members_Make_MemberInputs */
/** @typedef {{}} Ws_Members_No_MatchInputs */
/** @typedef {{}} Ws_Members_No_RolesInputs */
/** @typedef {{}} Ws_Members_Not_FoundInputs */
/** @typedef {{}} Ws_Members_OwnerInputs */
/** @typedef {{ date: NonNullable<unknown> }} Ws_Members_Owner_NoteInputs */
/** @typedef {{}} Ws_Members_RemoveInputs */
/** @typedef {{}} Ws_Members_Remove_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Members_Remove_FailedInputs */
/** @typedef {{}} Ws_Members_Remove_LabelInputs */
/** @typedef {{}} Ws_Members_Remove_NoteInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Members_Remove_TitleInputs */
/** @typedef {{}} Ws_Members_RolesInputs */
/** @typedef {{}} Ws_Members_Roles_AboveInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Members_Roles_FailedInputs */
/** @typedef {{}} Ws_Members_Roles_Not_AllowedInputs */
/** @typedef {{}} Ws_Members_SearchInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Members_SelectInputs */
/** @typedef {{}} Ws_Members_Select_AllInputs */
/** @typedef {{ count: NonNullable<unknown> }} Ws_Members_SelectedInputs */
/** @typedef {{}} Ws_Members_To_Guest_BodyInputs */
/** @typedef {{}} Ws_Members_To_Guest_NoteInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Members_To_Guest_TitleInputs */
/** @typedef {{}} Ws_Members_To_Member_NoteInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_MenuInputs */
/** @typedef {{}} Ws_Menu_InviteInputs */
/** @typedef {{}} Ws_Menu_NewInputs */
/** @typedef {{}} Ws_Menu_SettingsInputs */
/** @typedef {{}} Ws_Missing_BodyInputs */
/** @typedef {{}} Ws_Missing_TitleInputs */
/** @typedef {{}} Ws_My_CasesInputs */
/** @typedef {{ count: NonNullable<unknown> }} Ws_My_Cases_ChipInputs */
/** @typedef {{}} Ws_New_CreateInputs */
/** @typedef {{}} Ws_New_DescriptionInputs */
/** @typedef {{}} Ws_New_FailedInputs */
/** @typedef {{}} Ws_New_TitleInputs */
/** @typedef {{}} Ws_Perm_Emoji_CreateInputs */
/** @typedef {{}} Ws_Perm_Emoji_ManageInputs */
/** @typedef {{}} Ws_Perm_Issue_ManageInputs */
/** @typedef {{}} Ws_Perm_Member_ManageInputs */
/** @typedef {{}} Ws_Perm_Message_WriteInputs */
/** @typedef {{}} Ws_Perm_Page_WriteInputs */
/** @typedef {{}} Ws_Perm_Role_ManageInputs */
/** @typedef {{}} Ws_Perm_Space_ManageInputs */
/** @typedef {{}} Ws_Perm_Workspace_InviteInputs */
/** @typedef {{}} Ws_Perm_Workspace_ManageInputs */
/** @typedef {{}} Ws_Profile_AvatarInputs */
/** @typedef {{}} Ws_Profile_Avatar_NoteInputs */
/** @typedef {{}} Ws_Profile_Avatar_ResetInputs */
/** @typedef {{}} Ws_Profile_NameInputs */
/** @typedef {{}} Ws_Profile_Name_NoteInputs */
/** @typedef {{}} Ws_RailInputs */
/** @typedef {{}} Ws_Rail_NewInputs */
/** @typedef {{}} Ws_Roles_Above_YouInputs */
/** @typedef {{}} Ws_Roles_CreateInputs */
/** @typedef {{}} Ws_Roles_Create_FailedInputs */
/** @typedef {{}} Ws_Roles_Default_NoteInputs */
/** @typedef {{}} Ws_Roles_Default_SubInputs */
/** @typedef {{ count: NonNullable<unknown> }} Ws_Roles_Delete_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Roles_Delete_FailedInputs */
/** @typedef {{}} Ws_Roles_Delete_LabelInputs */
/** @typedef {{}} Ws_Roles_Delete_NoteInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Roles_Delete_TitleInputs */
/** @typedef {{}} Ws_Roles_ListInputs */
/** @typedef {{}} Ws_Roles_NameInputs */
/** @typedef {{}} Ws_Roles_Name_ExampleInputs */
/** @typedef {{}} Ws_Roles_NewInputs */
/** @typedef {{}} Ws_Roles_Not_AllowedInputs */
/** @typedef {{}} Ws_Roles_Not_FoundInputs */
/** @typedef {{}} Ws_Roles_NoteInputs */
/** @typedef {{}} Ws_Roles_Only_YoursInputs */
/** @typedef {{}} Ws_Roles_PermissionsInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Roles_Permissions_FailedInputs */
/** @typedef {{}} Ws_Roles_PositionInputs */
/** @typedef {{}} Ws_Roles_Position_NoteInputs */
/** @typedef {{ position: NonNullable<unknown> }} Ws_Roles_Position_SubInputs */
/** @typedef {{}} Ws_Save_FailedInputs */
/** @typedef {{}} Ws_Settings_AdminInputs */
/** @typedef {{}} Ws_Settings_BackInputs */
/** @typedef {{}} Ws_Settings_FeaturesInputs */
/** @typedef {{}} Ws_Settings_Features_DescriptionInputs */
/** @typedef {{}} Ws_Settings_GeneralInputs */
/** @typedef {{}} Ws_Settings_General_DescriptionInputs */
/** @typedef {{}} Ws_Settings_Index_DescriptionInputs */
/** @typedef {{}} Ws_Settings_InvitesInputs */
/** @typedef {{}} Ws_Settings_Invites_DescriptionInputs */
/** @typedef {{}} Ws_Settings_MembersInputs */
/** @typedef {{}} Ws_Settings_Members_DescriptionInputs */
/** @typedef {{}} Ws_Settings_Not_AllowedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Settings_OfInputs */
/** @typedef {{}} Ws_Settings_PersonalInputs */
/** @typedef {{}} Ws_Settings_ProfileInputs */
/** @typedef {{}} Ws_Settings_Profile_DescriptionInputs */
/** @typedef {{}} Ws_Settings_RolesInputs */
/** @typedef {{}} Ws_Settings_Roles_DescriptionInputs */
/** @typedef {{}} Ws_Settings_SpacesInputs */
/** @typedef {{}} Ws_Settings_Spaces_DescriptionInputs */
/** @typedef {{}} Ws_Settings_TitleInputs */
/** @typedef {{}} Ws_Slug_FormatInputs */
/** @typedef {{}} Ws_Slug_ReservedInputs */
/** @typedef {{}} Ws_Slug_TakenInputs */
/** @typedef {{}} Ws_Spaces_Add_ManagerInputs */
/** @typedef {{}} Ws_Spaces_Add_MemberInputs */
/** @typedef {{}} Ws_Spaces_Anyone_NoteInputs */
/** @typedef {{}} Ws_Spaces_ArchiveInputs */
/** @typedef {{}} Ws_Spaces_Archive_LabelInputs */
/** @typedef {{}} Ws_Spaces_Archive_NoteInputs */
/** @typedef {{}} Ws_Spaces_ArchivedInputs */
/** @typedef {{}} Ws_Spaces_Archived_NoteInputs */
/** @typedef {{}} Ws_Spaces_CreateInputs */
/** @typedef {{}} Ws_Spaces_Create_FailedInputs */
/** @typedef {{}} Ws_Spaces_Create_Not_AllowedInputs */
/** @typedef {{}} Ws_Spaces_Delete_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Spaces_Delete_FailedInputs */
/** @typedef {{}} Ws_Spaces_Delete_NoteInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Spaces_Delete_TitleInputs */
/** @typedef {{}} Ws_Spaces_DescriptionInputs */
/** @typedef {{}} Ws_Spaces_Description_PlaceholderInputs */
/** @typedef {{}} Ws_Spaces_FeaturesInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Spaces_Features_FailedInputs */
/** @typedef {{}} Ws_Spaces_ListInputs */
/** @typedef {{}} Ws_Spaces_ManagersInputs */
/** @typedef {{}} Ws_Spaces_MembersInputs */
/** @typedef {{}} Ws_Spaces_Members_NoteInputs */
/** @typedef {{}} Ws_Spaces_NameInputs */
/** @typedef {{}} Ws_Spaces_NarrowInputs */
/** @typedef {{}} Ws_Spaces_Narrow_Members_BodyInputs */
/** @typedef {{}} Ws_Spaces_Narrow_Private_BodyInputs */
/** @typedef {{ name: NonNullable<unknown>, visibility: NonNullable<unknown> }} Ws_Spaces_Narrow_TitleInputs */
/** @typedef {{}} Ws_Spaces_NewInputs */
/** @typedef {{}} Ws_Spaces_No_ManagersInputs */
/** @typedef {{}} Ws_Spaces_No_MembersInputs */
/** @typedef {{}} Ws_Spaces_Not_AllowedInputs */
/** @typedef {{}} Ws_Spaces_Not_FoundInputs */
/** @typedef {{}} Ws_Spaces_Private_NoteInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Spaces_Remove_PersonInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Spaces_Remove_Person_FailedInputs */
/** @typedef {{}} Ws_Spaces_UnarchiveInputs */
/** @typedef {{}} Ws_Spaces_Unarchive_NoteInputs */
/** @typedef {{}} Ws_Spaces_VisibilityInputs */
/** @typedef {{}} Ws_Visibility_AnyoneInputs */
/** @typedef {{}} Ws_Visibility_MembersInputs */
/** @typedef {{}} Ws_Visibility_PrivateInputs */
import * as registry from "../registry.js"


export const auth_banned = /** @type {(inputs: Auth_BannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This account has been suspended. If you think this is a mistake, contact the operator.`)
};

export const auth_mail_send_failed = /** @type {(inputs: Auth_Mail_Send_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't send the email`)
};

export const auth_resend_too_soon = /** @type {(inputs: Auth_Resend_Too_SoonInputs) => LocalizedString} */ (i) => {const secondsPlural = registry.plural("en", i?.seconds, {});
	if (secondsPlural === "one") return /** @type {LocalizedString} */ (`You can request a new code once every ${i?.seconds} second`);
	if (secondsPlural === "other") return /** @type {LocalizedString} */ (`You can request a new code once every ${i?.seconds} seconds`);
	return /** @type {LocalizedString} */ ("auth_resend_too_soon");
};

export const cv_as_broadcast = /** @type {(inputs: Cv_As_BroadcastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As a broadcast`)
};

export const cv_broadcast = /** @type {(inputs: Cv_BroadcastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Broadcast`)
};

export const cv_broadcast_hint = /** @type {(inputs: Cv_Broadcast_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A broadcast reaches everyone who sees this space. It takes no replies.`)
};

export const cv_broadcast_no_reply = /** @type {(inputs: Cv_Broadcast_No_ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Broadcasts take no replies.`)
};

export const cv_cancel = /** @type {(inputs: Cv_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

export const cv_cannot_post = /** @type {(inputs: Cv_Cannot_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You cannot write in this conversation.`)
};

export const cv_col_last_message = /** @type {(inputs: Cv_Col_Last_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last message`)
};

export const cv_col_name = /** @type {(inputs: Cv_Col_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

export const cv_col_space = /** @type {(inputs: Cv_Col_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Space`)
};

export const cv_col_updated = /** @type {(inputs: Cv_Col_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated`)
};

export const cv_dm_empty = /** @type {(inputs: Cv_Dm_EmptyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No messages with ${i?.name} yet. The first one starts it.`)
};

export const cv_dm_empty_group = /** @type {(inputs: Cv_Dm_Empty_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No messages with ${i?.names} yet. The first one starts it.`)
};

export const cv_dm_empty_self = /** @type {(inputs: Cv_Dm_Empty_SelfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This one is just for you. Keep notes and drafts here.`)
};

export const cv_dm_empty_unknown = /** @type {(inputs: Cv_Dm_Empty_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No messages yet. The first one starts it.`)
};

export const cv_dm_last = /** @type {(inputs: Cv_Dm_LastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Last message ${i?.when}`)
};

export const cv_dm_members = /** @type {(inputs: Cv_Dm_MembersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} members`)
};

export const cv_dm_menu = /** @type {(inputs: Cv_Dm_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direct message menu`)
};

export const cv_dm_self_name = /** @type {(inputs: Cv_Dm_Self_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} (you)`)
};

export const cv_dms = /** @type {(inputs: Cv_DmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DM`)
};

export const cv_dms_empty = /** @type {(inputs: Cv_Dms_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No direct messages yet.`)
};

export const cv_dms_none_match = /** @type {(inputs: Cv_Dms_None_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No direct message matches.`)
};

export const cv_dms_none_unread = /** @type {(inputs: Cv_Dms_None_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No unread direct messages.`)
};

export const cv_dms_start = /** @type {(inputs: Cv_Dms_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start a DM`)
};

export const cv_edit = /** @type {(inputs: Cv_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit`)
};

export const cv_edit_label = /** @type {(inputs: Cv_Edit_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit the message`)
};

export const cv_emoji_add = /** @type {(inputs: Cv_Emoji_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add`)
};

export const cv_emoji_add_section = /** @type {(inputs: Cv_Emoji_Add_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add`)
};

export const cv_emoji_cannot_add = /** @type {(inputs: Cv_Emoji_Cannot_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You may not add emoji.`)
};

export const cv_emoji_choose = /** @type {(inputs: Cv_Emoji_ChooseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose`)
};

export const cv_emoji_choose_image = /** @type {(inputs: Cv_Emoji_Choose_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose an image`)
};

export const cv_emoji_empty = /** @type {(inputs: Cv_Emoji_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No emoji yet.`)
};

export const cv_emoji_full = /** @type {(inputs: Cv_Emoji_FullInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Up to ${i?.max} emoji`)
};

export const cv_emoji_image = /** @type {(inputs: Cv_Emoji_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image`)
};

export const cv_emoji_image_note = /** @type {(inputs: Cv_Emoji_Image_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A near square image (up to ${i?.kb}KB)`)
};

export const cv_emoji_list = /** @type {(inputs: Cv_Emoji_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`List`)
};

export const cv_emoji_name = /** @type {(inputs: Cv_Emoji_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

export const cv_emoji_name_note = /** @type {(inputs: Cv_Emoji_Name_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lowercase letters, digits, _ and -`)
};

export const cv_emoji_name_rule = /** @type {(inputs: Cv_Emoji_Name_RuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A name is up to 32 lowercase letters, digits, _ and -`)
};

export const cv_emoji_no_image = /** @type {(inputs: Cv_Emoji_No_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`None chosen`)
};

export const cv_emoji_pick_image = /** @type {(inputs: Cv_Emoji_Pick_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose an image`)
};

export const cv_emoji_remove = /** @type {(inputs: Cv_Emoji_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

export const cv_emoji_remove_body = /** @type {(inputs: Cv_Emoji_Remove_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`:${i?.name}: in messages and reactions will show as text, not the image.`)
};

export const cv_emoji_remove_label = /** @type {(inputs: Cv_Emoji_Remove_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove :${i?.name}:`)
};

export const cv_emoji_remove_title = /** @type {(inputs: Cv_Emoji_Remove_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove :${i?.name}:?`)
};

export const cv_emoji_too_large = /** @type {(inputs: Cv_Emoji_Too_LargeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Images are up to ${i?.kb}KB`)
};

export const cv_filter = /** @type {(inputs: Cv_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter`)
};

export const cv_filter_all = /** @type {(inputs: Cv_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

export const cv_filter_broadcasts = /** @type {(inputs: Cv_Filter_BroadcastsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Broadcasts`)
};

export const cv_filter_space = /** @type {(inputs: Cv_Filter_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Narrow to a space`)
};

export const cv_filter_space_all = /** @type {(inputs: Cv_Filter_Space_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All spaces`)
};

export const cv_filter_unread = /** @type {(inputs: Cv_Filter_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unread`)
};

export const cv_inbox = /** @type {(inputs: Cv_InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inbox`)
};

export const cv_inbox_reason_posted = /** @type {(inputs: Cv_Inbox_Reason_PostedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You wrote here`)
};

export const cv_load_failed = /** @type {(inputs: Cv_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not load`)
};

export const cv_loading_older = /** @type {(inputs: Cv_Loading_OlderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading…`)
};

export const cv_mark_read = /** @type {(inputs: Cv_Mark_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark as read`)
};

export const cv_me_dms = /** @type {(inputs: Cv_Me_DmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DM`)
};

export const cv_members_count = /** @type {(inputs: Cv_Members_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} members`)
};

export const cv_members_more = /** @type {(inputs: Cv_Members_MoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`and ${i?.count} more`)
};

export const cv_mention_cannot_see = /** @type {(inputs: Cv_Mention_Cannot_SeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cannot see this space`)
};

export const cv_message_menu = /** @type {(inputs: Cv_Message_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message menu`)
};

export const cv_move = /** @type {(inputs: Cv_MoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move to another space`)
};

export const cv_move_action = /** @type {(inputs: Cv_Move_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move`)
};

export const cv_narrow = /** @type {(inputs: Cv_NarrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Narrow the list`)
};

export const cv_narrow_name = /** @type {(inputs: Cv_Narrow_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Narrow by name`)
};

export const cv_narrow_title = /** @type {(inputs: Cv_Narrow_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Narrow by title`)
};

export const cv_new_dm = /** @type {(inputs: Cv_New_DmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New DM`)
};

export const cv_new_dm_chosen = /** @type {(inputs: Cv_New_Dm_ChosenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chosen`)
};

export const cv_new_dm_limit = /** @type {(inputs: Cv_New_Dm_LimitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Up to ${i?.max} people`)
};

export const cv_new_dm_nobody = /** @type {(inputs: Cv_New_Dm_NobodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nobody found`)
};

export const cv_new_dm_people = /** @type {(inputs: Cv_New_Dm_PeopleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`People`)
};

export const cv_new_dm_search = /** @type {(inputs: Cv_New_Dm_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find by name`)
};

export const cv_new_dm_start = /** @type {(inputs: Cv_New_Dm_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start`)
};

export const cv_new_dm_unpick = /** @type {(inputs: Cv_New_Dm_UnpickInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.name}`)
};

export const cv_new_topic = /** @type {(inputs: Cv_New_TopicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New topic`)
};

export const cv_new_topic_hint = /** @type {(inputs: Cv_New_Topic_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A name is optional. Without one, the list shows the first message.`)
};

export const cv_new_topic_in = /** @type {(inputs: Cv_New_Topic_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Space`)
};

export const cv_no_description = /** @type {(inputs: Cv_No_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No description.`)
};

export const cv_no_space = /** @type {(inputs: Cv_No_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No space takes topics.`)
};

export const cv_not_found = /** @type {(inputs: Cv_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This conversation is not there or cannot be seen.`)
};

export const cv_pin = /** @type {(inputs: Cv_PinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pin to this space`)
};

export const cv_pin_down = /** @type {(inputs: Cv_Pin_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Down`)
};

export const cv_pin_down_label = /** @type {(inputs: Cv_Pin_Down_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Move ${i?.name} down`)
};

export const cv_pin_gone = /** @type {(inputs: Cv_Pin_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not visible`)
};

export const cv_pin_up = /** @type {(inputs: Cv_Pin_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Up`)
};

export const cv_pin_up_label = /** @type {(inputs: Cv_Pin_Up_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Move ${i?.name} up`)
};

export const cv_pins = /** @type {(inputs: Cv_PinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pinned`)
};

export const cv_pins_empty = /** @type {(inputs: Cv_Pins_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing pinned.`)
};

export const cv_pins_empty_can = /** @type {(inputs: Cv_Pins_Empty_CanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing pinned. Pin a topic or a document from its menu.`)
};

export const cv_post_label = /** @type {(inputs: Cv_Post_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message`)
};

export const cv_post_placeholder = /** @type {(inputs: Cv_Post_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write and send`)
};

export const cv_post_placeholder_dm = /** @type {(inputs: Cv_Post_Placeholder_DmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Message ${i?.name}`)
};

export const cv_post_placeholder_dm_group = /** @type {(inputs: Cv_Post_Placeholder_Dm_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Message ${i?.names}`)
};

export const cv_post_placeholder_dm_self = /** @type {(inputs: Cv_Post_Placeholder_Dm_SelfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jot something down`)
};

export const cv_react = /** @type {(inputs: Cv_ReactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a reaction`)
};

export const cv_react_none = /** @type {(inputs: Cv_React_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing found`)
};

export const cv_react_search = /** @type {(inputs: Cv_React_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find an emoji`)
};

export const cv_reaction_check = /** @type {(inputs: Cv_Reaction_CheckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checked`)
};

export const cv_reaction_eye = /** @type {(inputs: Cv_Reaction_EyeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seen`)
};

export const cv_reaction_label = /** @type {(inputs: Cv_Reaction_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ${i?.count}`)
};

export const cv_reactions = /** @type {(inputs: Cv_ReactionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reactions`)
};

export const cv_recent_topics = /** @type {(inputs: Cv_Recent_TopicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recent topics`)
};

export const cv_remove = /** @type {(inputs: Cv_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

export const cv_remove_body = /** @type {(inputs: Cv_Remove_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This message becomes a line saying it was removed, and its files and reactions go too. This cannot be undone.`)
};

export const cv_remove_title = /** @type {(inputs: Cv_Remove_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove this message?`)
};

export const cv_rename = /** @type {(inputs: Cv_RenameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rename`)
};

export const cv_rename_action = /** @type {(inputs: Cv_Rename_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rename`)
};

export const cv_save = /** @type {(inputs: Cv_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save`)
};

export const cv_save_failed = /** @type {(inputs: Cv_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not save`)
};

export const cv_send_failed = /** @type {(inputs: Cv_Send_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not send`)
};

export const cv_settings_emoji = /** @type {(inputs: Cv_Settings_EmojiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emoji`)
};

export const cv_settings_emoji_description = /** @type {(inputs: Cv_Settings_Emoji_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emoji only this workspace uses, written as :name: in messages and reactions.`)
};

export const cv_settings_emoji_short = /** @type {(inputs: Cv_Settings_Emoji_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emoji only this workspace uses`)
};

export const cv_space = /** @type {(inputs: Cv_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Space`)
};

export const cv_space_missing = /** @type {(inputs: Cv_Space_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This space is not there or cannot be seen.`)
};

export const cv_space_overview = /** @type {(inputs: Cv_Space_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Space overview`)
};

export const cv_start_here = /** @type {(inputs: Cv_Start_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start a topic here`)
};

export const cv_suggest_emoji = /** @type {(inputs: Cv_Suggest_EmojiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emoji`)
};

export const cv_suggest_links = /** @type {(inputs: Cv_Suggest_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topics to link`)
};

export const cv_suggest_people = /** @type {(inputs: Cv_Suggest_PeopleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Members`)
};

export const cv_too_long = /** @type {(inputs: Cv_Too_LongInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Up to ${i?.max} characters`)
};

export const cv_topic = /** @type {(inputs: Cv_TopicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topic`)
};

export const cv_topic_menu = /** @type {(inputs: Cv_Topic_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topic menu`)
};

export const cv_topic_name = /** @type {(inputs: Cv_Topic_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

export const cv_topic_name_placeholder = /** @type {(inputs: Cv_Topic_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name (optional)`)
};

export const cv_topics = /** @type {(inputs: Cv_TopicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topics`)
};

export const cv_topics_empty = /** @type {(inputs: Cv_Topics_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No topics yet.`)
};

export const cv_topics_none_match = /** @type {(inputs: Cv_Topics_None_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No topics match.`)
};

export const cv_topics_start = /** @type {(inputs: Cv_Topics_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start a Topic`)
};

export const cv_unpin = /** @type {(inputs: Cv_UnpinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unpin`)
};

export const cv_unpin_label = /** @type {(inputs: Cv_Unpin_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unpin ${i?.name}`)
};

export const cv_unread_dot = /** @type {(inputs: Cv_Unread_DotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unread`)
};

export const desktop_client_not_allowed = /** @type {(inputs: Desktop_Client_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This app can't be used as trameria desktop`)
};

export const desktop_scope_missing = /** @type {(inputs: Desktop_Scope_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This sign-in isn't for trameria desktop`)
};

export const desktop_token_expired = /** @type {(inputs: Desktop_Token_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your sign-in has expired. Please sign in again`)
};

export const desktop_token_invalid = /** @type {(inputs: Desktop_Token_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invalid token`)
};

export const desktop_token_missing = /** @type {(inputs: Desktop_Token_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to trameria desktop to continue`)
};

export const desktop_token_revoked = /** @type {(inputs: Desktop_Token_RevokedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This app has been disconnected. Please sign in again`)
};

export const desktop_waitlisted = /** @type {(inputs: Desktop_WaitlistedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your account is awaiting approval`)
};

export const issues_activity = /** @type {(inputs: Issues_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ACTIVITY`)
};

export const issues_activity_assignee_clear = /** @type {(inputs: Issues_Activity_Assignee_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`removed the assignee`)
};

export const issues_activity_assignee_set = /** @type {(inputs: Issues_Activity_Assignee_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`set the assignee to ${i?.to}`)
};

export const issues_activity_created = /** @type {(inputs: Issues_Activity_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`created the Issue`)
};

export const issues_activity_cycle_clear = /** @type {(inputs: Issues_Activity_Cycle_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`removed the Cycle`)
};

export const issues_activity_cycle_set = /** @type {(inputs: Issues_Activity_Cycle_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`set the Cycle to ${i?.to}`)
};

export const issues_activity_due_clear = /** @type {(inputs: Issues_Activity_Due_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`removed the due date`)
};

export const issues_activity_due_set = /** @type {(inputs: Issues_Activity_Due_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`set the due date to ${i?.to}`)
};

export const issues_activity_label_added = /** @type {(inputs: Issues_Activity_Label_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`added the label ${i?.label}`)
};

export const issues_activity_label_removed = /** @type {(inputs: Issues_Activity_Label_RemovedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`removed the label ${i?.label}`)
};

export const issues_activity_line = /** @type {(inputs: Issues_Activity_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (` ${i?.text}`)
};

export const issues_activity_milestone_clear = /** @type {(inputs: Issues_Activity_Milestone_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`removed the milestone`)
};

export const issues_activity_milestone_set = /** @type {(inputs: Issues_Activity_Milestone_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`set the milestone to ${i?.to}`)
};

export const issues_activity_project_clear = /** @type {(inputs: Issues_Activity_Project_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`removed the Project`)
};

export const issues_activity_project_set = /** @type {(inputs: Issues_Activity_Project_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`set the Project to ${i?.to}`)
};

export const issues_activity_state = /** @type {(inputs: Issues_Activity_StateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`changed the status to ${i?.to}`)
};

export const issues_activity_team_clear = /** @type {(inputs: Issues_Activity_Team_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`removed the Team`)
};

export const issues_activity_team_set = /** @type {(inputs: Issues_Activity_Team_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`set the Team to ${i?.to}`)
};

export const issues_activity_title = /** @type {(inputs: Issues_Activity_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`changed the title to "${i?.to}"`)
};

export const issues_add_label = /** @type {(inputs: Issues_Add_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add label`)
};

export const issues_ai_memo = /** @type {(inputs: Issues_Ai_MemoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI memo`)
};

export const issues_all = /** @type {(inputs: Issues_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

export const issues_cancel = /** @type {(inputs: Issues_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

export const issues_cannot_undo = /** @type {(inputs: Issues_Cannot_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This can't be undone.`)
};

export const issues_change_assignee = /** @type {(inputs: Issues_Change_AssigneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change assignee`)
};

export const issues_change_cycle = /** @type {(inputs: Issues_Change_CycleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change Cycle`)
};

export const issues_change_due = /** @type {(inputs: Issues_Change_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change due date`)
};

export const issues_change_milestone = /** @type {(inputs: Issues_Change_MilestoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change milestone`)
};

export const issues_change_project = /** @type {(inputs: Issues_Change_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change Project`)
};

export const issues_change_space = /** @type {(inputs: Issues_Change_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change Space`)
};

export const issues_change_state = /** @type {(inputs: Issues_Change_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change status`)
};

export const issues_change_target_date = /** @type {(inputs: Issues_Change_Target_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change the due date`)
};

export const issues_change_team = /** @type {(inputs: Issues_Change_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change Team`)
};

export const issues_choose_milestone = /** @type {(inputs: Issues_Choose_MilestoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a milestone`)
};

export const issues_choose_team_first = /** @type {(inputs: Issues_Choose_Team_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a Team first`)
};

export const issues_clear_due = /** @type {(inputs: Issues_Clear_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear due date`)
};

export const issues_close = /** @type {(inputs: Issues_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

export const issues_col_assignee = /** @type {(inputs: Issues_Col_AssigneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assignee`)
};

export const issues_col_due = /** @type {(inputs: Issues_Col_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due date`)
};

export const issues_col_name = /** @type {(inputs: Issues_Col_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

export const issues_col_project = /** @type {(inputs: Issues_Col_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project`)
};

export const issues_col_space = /** @type {(inputs: Issues_Col_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Space`)
};

export const issues_col_state = /** @type {(inputs: Issues_Col_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

export const issues_col_updated = /** @type {(inputs: Issues_Col_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated`)
};

export const issues_comment_edit_label = /** @type {(inputs: Issues_Comment_Edit_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit comment`)
};

export const issues_comment_failed = /** @type {(inputs: Issues_Comment_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't send the comment`)
};

export const issues_comment_label = /** @type {(inputs: Issues_Comment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment`)
};

export const issues_comment_menu = /** @type {(inputs: Issues_Comment_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment actions`)
};

export const issues_comment_placeholder = /** @type {(inputs: Issues_Comment_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write a comment…`)
};

export const issues_comment_remove_title = /** @type {(inputs: Issues_Comment_Remove_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete comment "${i?.excerpt}"?`)
};

export const issues_comments = /** @type {(inputs: Issues_CommentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comments`)
};

export const issues_create = /** @type {(inputs: Issues_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Issue`)
};

export const issues_create_failed = /** @type {(inputs: Issues_Create_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't create the Issue`)
};

export const issues_create_hint = /** @type {(inputs: Issues_Create_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Also ⌘↵ to create`)
};

export const issues_cycle_active_tag = /** @type {(inputs: Issues_Cycle_Active_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active`)
};

export const issues_cycle_add_next = /** @type {(inputs: Issues_Cycle_Add_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add the next cycle`)
};

export const issues_cycle_days_left = /** @type {(inputs: Issues_Cycle_Days_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} days left`)
};

export const issues_cycle_done_tag = /** @type {(inputs: Issues_Cycle_Done_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completed`)
};

export const issues_cycle_empty = /** @type {(inputs: Issues_Cycle_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No issues in this cycle yet. Add them from an issue's Cycle.`)
};

export const issues_cycle_length = /** @type {(inputs: Issues_Cycle_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cycle length`)
};

export const issues_cycle_menu = /** @type {(inputs: Issues_Cycle_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cycle actions`)
};

export const issues_cycle_meta_active = /** @type {(inputs: Issues_Cycle_Meta_ActiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`In progress · ${i?.left}`)
};

export const issues_cycle_meta_done = /** @type {(inputs: Issues_Cycle_Meta_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Done · ${i?.from}–${i?.to}`)
};

export const issues_cycle_meta_not_started = /** @type {(inputs: Issues_Cycle_Meta_Not_StartedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.starts} · Not started yet`)
};

export const issues_cycle_not_found = /** @type {(inputs: Issues_Cycle_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cycle not found. The URL is wrong, or it was deleted.`)
};

export const issues_cycle_planned_tag = /** @type {(inputs: Issues_Cycle_Planned_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planned`)
};

export const issues_cycle_remove = /** @type {(inputs: Issues_Cycle_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this cycle`)
};

export const issues_cycle_remove_action = /** @type {(inputs: Issues_Cycle_Remove_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

export const issues_cycle_remove_body = /** @type {(inputs: Issues_Cycle_Remove_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Its issues stay and leave the cycle. This can't be undone.`)
};

export const issues_cycle_remove_title = /** @type {(inputs: Issues_Cycle_Remove_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete ${i?.name} (${i?.team})?`)
};

export const issues_cycle_sub = /** @type {(inputs: Issues_Cycle_SubInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.starts} · ${i?.pct}% · ${i?.count} issues`)
};

export const issues_cycle_sub_planned = /** @type {(inputs: Issues_Cycle_Sub_PlannedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.starts} · ${i?.count} issues planned`)
};

export const issues_cycles_empty = /** @type {(inputs: Issues_Cycles_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No cycles yet`)
};

export const issues_cycles_none_match = /** @type {(inputs: Issues_Cycles_None_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No matching cycles`)
};

export const issues_days_unit = /** @type {(inputs: Issues_Days_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`days`)
};

export const issues_edit = /** @type {(inputs: Issues_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit`)
};

export const issues_empty = /** @type {(inputs: Issues_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Issues yet`)
};

export const issues_end_date = /** @type {(inputs: Issues_End_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End date`)
};

export const issues_filter_space = /** @type {(inputs: Issues_Filter_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Narrow to a space`)
};

export const issues_filter_space_all = /** @type {(inputs: Issues_Filter_Space_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All spaces`)
};

export const issues_filter_team = /** @type {(inputs: Issues_Filter_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter by team`)
};

export const issues_former_member = /** @type {(inputs: Issues_Former_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Former member`)
};

export const issues_group_by = /** @type {(inputs: Issues_Group_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group by`)
};

export const issues_group_by_assignee = /** @type {(inputs: Issues_Group_By_AssigneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By assignee`)
};

export const issues_group_by_project = /** @type {(inputs: Issues_Group_By_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By Project`)
};

export const issues_group_by_state = /** @type {(inputs: Issues_Group_By_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By status`)
};

export const issues_group_by_team = /** @type {(inputs: Issues_Group_By_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By Team`)
};

export const issues_group_no_project = /** @type {(inputs: Issues_Group_No_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Project`)
};

export const issues_group_no_team = /** @type {(inputs: Issues_Group_No_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Team`)
};

export const issues_load_failed = /** @type {(inputs: Issues_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't load`)
};

export const issues_make_first = /** @type {(inputs: Issues_Make_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create an Issue`)
};

export const issues_make_project = /** @type {(inputs: Issues_Make_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a project`)
};

export const issues_make_team = /** @type {(inputs: Issues_Make_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a team`)
};

export const issues_menu = /** @type {(inputs: Issues_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issue actions`)
};

export const issues_milestone_add = /** @type {(inputs: Issues_Milestone_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Milestone`)
};

export const issues_milestone_add_row = /** @type {(inputs: Issues_Milestone_Add_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a milestone`)
};

export const issues_milestone_name = /** @type {(inputs: Issues_Milestone_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Milestone name`)
};

export const issues_milestone_name_example = /** @type {(inputs: Issues_Milestone_Name_ExampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`M4 retrospective`)
};

export const issues_milestone_new_name = /** @type {(inputs: Issues_Milestone_New_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New milestone name`)
};

export const issues_milestone_remove = /** @type {(inputs: Issues_Milestone_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete the milestone “${i?.name}”`)
};

export const issues_milestone_remove_body = /** @type {(inputs: Issues_Milestone_Remove_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Its issues stay and leave the milestone. This can't be undone.`)
};

export const issues_milestone_remove_row = /** @type {(inputs: Issues_Milestone_Remove_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove the milestone`)
};

export const issues_milestone_remove_title = /** @type {(inputs: Issues_Milestone_Remove_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete the milestone “${i?.name}”?`)
};

export const issues_milestone_rename = /** @type {(inputs: Issues_Milestone_RenameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rename the milestone “${i?.name}”`)
};

export const issues_milestone_row_placeholder = /** @type {(inputs: Issues_Milestone_Row_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. M1 spec settled`)
};

export const issues_narrow = /** @type {(inputs: Issues_NarrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Narrow the issues`)
};

export const issues_narrow_cycles = /** @type {(inputs: Issues_Narrow_CyclesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter cycles`)
};

export const issues_narrow_cycles_placeholder = /** @type {(inputs: Issues_Narrow_Cycles_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter by cycle or team`)
};

export const issues_narrow_placeholder = /** @type {(inputs: Issues_Narrow_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter by title`)
};

export const issues_narrow_projects = /** @type {(inputs: Issues_Narrow_ProjectsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter projects`)
};

export const issues_narrow_projects_placeholder = /** @type {(inputs: Issues_Narrow_Projects_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter by name`)
};

export const issues_nav = /** @type {(inputs: Issues_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issues`)
};

export const issues_new = /** @type {(inputs: Issues_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New issue`)
};

export const issues_new_project = /** @type {(inputs: Issues_New_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New project`)
};

export const issues_new_team = /** @type {(inputs: Issues_New_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New team`)
};

export const issues_new_team_cycle_days = /** @type {(inputs: Issues_New_Team_Cycle_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cycle length (days)`)
};

export const issues_new_team_name_placeholder = /** @type {(inputs: Issues_New_Team_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Web platform`)
};

export const issues_new_team_note = /** @type {(inputs: Issues_New_Team_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A team runs cycles. Creating one makes a cycle starting today and the next two.`)
};

export const issues_no_activity = /** @type {(inputs: Issues_No_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No activity yet`)
};

export const issues_no_cycle = /** @type {(inputs: Issues_No_CycleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Cycle`)
};

export const issues_no_due = /** @type {(inputs: Issues_No_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No due date`)
};

export const issues_no_milestone = /** @type {(inputs: Issues_No_MilestoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No milestone`)
};

export const issues_no_permission = /** @type {(inputs: Issues_No_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You don't have permission to create an Issue. issue.manage is required. Ask someone with the role.`)
};

export const issues_no_permission_project = /** @type {(inputs: Issues_No_Permission_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You don't have permission to create a project. issue.manage is required. Ask someone with the role.`)
};

export const issues_no_permission_team = /** @type {(inputs: Issues_No_Permission_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You don't have permission to create a team. issue.manage is required. Ask someone with the role.`)
};

export const issues_no_project = /** @type {(inputs: Issues_No_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Project`)
};

export const issues_no_space = /** @type {(inputs: Issues_No_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No space can hold Issues.`)
};

export const issues_no_space_project = /** @type {(inputs: Issues_No_Space_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No space can hold projects.`)
};

export const issues_no_space_team = /** @type {(inputs: Issues_No_Space_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No space has cycles on.`)
};

export const issues_no_team = /** @type {(inputs: Issues_No_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Team`)
};

export const issues_none = /** @type {(inputs: Issues_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`None`)
};

export const issues_none_match = /** @type {(inputs: Issues_None_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Issues match`)
};

export const issues_not_found = /** @type {(inputs: Issues_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issue not found. The URL is wrong, or it was deleted.`)
};

export const issues_not_set = /** @type {(inputs: Issues_Not_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not set`)
};

export const issues_note = /** @type {(inputs: Issues_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

export const issues_note_new_placeholder = /** @type {(inputs: Issues_Note_New_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a description…`)
};

export const issues_note_placeholder = /** @type {(inputs: Issues_Note_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write a description…`)
};

export const issues_progress_done = /** @type {(inputs: Issues_Progress_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.done}/${i?.total} done`)
};

export const issues_project_create = /** @type {(inputs: Issues_Project_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create project`)
};

export const issues_project_create_failed = /** @type {(inputs: Issues_Project_Create_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't create the project`)
};

export const issues_project_done = /** @type {(inputs: Issues_Project_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark done`)
};

export const issues_project_issue_count = /** @type {(inputs: Issues_Project_Issue_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`· ${i?.count} issues`)
};

export const issues_project_menu = /** @type {(inputs: Issues_Project_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project actions`)
};

export const issues_project_name = /** @type {(inputs: Issues_Project_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project name`)
};

export const issues_project_name_placeholder = /** @type {(inputs: Issues_Project_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project name`)
};

export const issues_project_not_found = /** @type {(inputs: Issues_Project_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project not found. The URL is wrong, or it was deleted.`)
};

export const issues_project_note_new_placeholder = /** @type {(inputs: Issues_Project_Note_New_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is this project for? Write the background and aims…`)
};

export const issues_project_note_placeholder = /** @type {(inputs: Issues_Project_Note_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is this project for…`)
};

export const issues_project_pct_target = /** @type {(inputs: Issues_Project_Pct_TargetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% · Due`)
};

export const issues_project_remove_body = /** @type {(inputs: Issues_Project_Remove_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Its issues stay and leave the project. Its milestones are deleted too. This can't be undone.`)
};

export const issues_project_remove_title = /** @type {(inputs: Issues_Project_Remove_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete the project “${i?.name}”?`)
};

export const issues_project_reopen = /** @type {(inputs: Issues_Project_ReopenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reopen`)
};

export const issues_project_sub = /** @type {(inputs: Issues_Project_SubInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% · ${i?.due} · Team ${i?.teams}`)
};

export const issues_project_summary = /** @type {(inputs: Issues_Project_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% · Due ${i?.due} · ${i?.count} issues`)
};

export const issues_projects_empty = /** @type {(inputs: Issues_Projects_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No projects yet`)
};

export const issues_projects_none_done = /** @type {(inputs: Issues_Projects_None_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No finished projects`)
};

export const issues_projects_none_match = /** @type {(inputs: Issues_Projects_None_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No matching projects`)
};

export const issues_projects_state = /** @type {(inputs: Issues_Projects_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter by state`)
};

export const issues_prop_assignee = /** @type {(inputs: Issues_Prop_AssigneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assignee`)
};

export const issues_prop_cycle = /** @type {(inputs: Issues_Prop_CycleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cycle`)
};

export const issues_prop_due = /** @type {(inputs: Issues_Prop_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due date`)
};

export const issues_prop_labels = /** @type {(inputs: Issues_Prop_LabelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Labels`)
};

export const issues_prop_milestone = /** @type {(inputs: Issues_Prop_MilestoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Milestone`)
};

export const issues_prop_project = /** @type {(inputs: Issues_Prop_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project`)
};

export const issues_prop_state = /** @type {(inputs: Issues_Prop_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

export const issues_prop_team = /** @type {(inputs: Issues_Prop_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team`)
};

export const issues_range_sep = /** @type {(inputs: Issues_Range_SepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`–`)
};

export const issues_reload = /** @type {(inputs: Issues_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reload`)
};

export const issues_reload_needed = /** @type {(inputs: Issues_Reload_NeededInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This app is out of date. Reload to write here.`)
};

export const issues_remove = /** @type {(inputs: Issues_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

export const issues_remove_body = /** @type {(inputs: Issues_Remove_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Its comments and activity will be deleted too. This can't be undone.`)
};

export const issues_remove_many_body = /** @type {(inputs: Issues_Remove_Many_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.names}. Their comments and activity will be deleted too. This can't be undone.`)
};

export const issues_remove_many_title = /** @type {(inputs: Issues_Remove_Many_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete ${i?.count} Issues?`)
};

export const issues_remove_title = /** @type {(inputs: Issues_Remove_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete "${i?.title}"?`)
};

export const issues_row_menu = /** @type {(inputs: Issues_Row_MenuInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Actions for "${i?.title}"`)
};

export const issues_save = /** @type {(inputs: Issues_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save`)
};

export const issues_save_failed = /** @type {(inputs: Issues_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't save`)
};

export const issues_set_state = /** @type {(inputs: Issues_Set_StateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Set to ${i?.state}`)
};

export const issues_someone = /** @type {(inputs: Issues_SomeoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Someone`)
};

export const issues_start_date = /** @type {(inputs: Issues_Start_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start date`)
};

export const issues_starts_on = /** @type {(inputs: Issues_Starts_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Starts ${i?.date}`)
};

export const issues_state_doing = /** @type {(inputs: Issues_State_DoingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In progress`)
};

export const issues_state_done = /** @type {(inputs: Issues_State_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done`)
};

export const issues_state_open = /** @type {(inputs: Issues_State_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To do`)
};

export const issues_state_review = /** @type {(inputs: Issues_State_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In review`)
};

export const issues_tab_cycles = /** @type {(inputs: Issues_Tab_CyclesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cycles`)
};

export const issues_tab_issues = /** @type {(inputs: Issues_Tab_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issues`)
};

export const issues_tab_projects = /** @type {(inputs: Issues_Tab_ProjectsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projects`)
};

export const issues_tab_upcoming = /** @type {(inputs: Issues_Tab_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upcoming`)
};

export const issues_tabs = /** @type {(inputs: Issues_TabsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issue lists`)
};

export const issues_target_date = /** @type {(inputs: Issues_Target_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due date`)
};

export const issues_team_create = /** @type {(inputs: Issues_Team_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create`)
};

export const issues_team_create_failed = /** @type {(inputs: Issues_Team_Create_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't create the team`)
};

export const issues_team_name = /** @type {(inputs: Issues_Team_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

export const issues_team_settings = /** @type {(inputs: Issues_Team_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team settings`)
};

export const issues_teams_empty = /** @type {(inputs: Issues_Teams_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No teams yet`)
};

export const issues_time_days_ago = /** @type {(inputs: Issues_Time_Days_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} days ago`)
};

export const issues_time_yesterday = /** @type {(inputs: Issues_Time_YesterdayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Yesterday ${i?.time}`)
};

export const issues_title_label = /** @type {(inputs: Issues_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

export const issues_title_placeholder = /** @type {(inputs: Issues_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issue title`)
};

export const issues_too_long = /** @type {(inputs: Issues_Too_LongInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Up to ${i?.max} characters`)
};

export const issues_unassigned = /** @type {(inputs: Issues_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unassigned`)
};

export const issues_upcoming_empty = /** @type {(inputs: Issues_Upcoming_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No issues waiting for a cycle`)
};

export const mail_approved_line_body = /** @type {(inputs: Mail_Approved_Line_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your waitlist request was approved. You can sign in at the URL below.`)
};

export const mail_approved_subject = /** @type {(inputs: Mail_Approved_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can now sign in to trameria`)
};

export const mail_sign_in_code_line_code = /** @type {(inputs: Mail_Sign_In_Code_Line_CodeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your trameria sign-in code is ${i?.otp}.`)
};

export const mail_sign_in_code_line_expires = /** @type {(inputs: Mail_Sign_In_Code_Line_ExpiresInputs) => LocalizedString} */ (i) => {const minutesPlural = registry.plural("en", i?.minutes, {});
	if (minutesPlural === "one") return /** @type {LocalizedString} */ (`It expires in ${i?.minutes} minute.`);
	if (minutesPlural === "other") return /** @type {LocalizedString} */ (`It expires in ${i?.minutes} minutes.`);
	return /** @type {LocalizedString} */ ("mail_sign_in_code_line_expires");
};

export const mail_sign_in_code_line_ignore = /** @type {(inputs: Mail_Sign_In_Code_Line_IgnoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you didn't request this, you can ignore this email.`)
};

export const mail_sign_in_code_subject = /** @type {(inputs: Mail_Sign_In_Code_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your trameria sign-in code`)
};

export const mail_waitlist_joined_line_body = /** @type {(inputs: Mail_Waitlist_Joined_Line_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.email} joined the waitlist.`)
};

export const mail_waitlist_joined_subject = /** @type {(inputs: Mail_Waitlist_Joined_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Someone joined the waitlist`)
};

export const publish_archived = /** @type {(inputs: Publish_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An archived document cannot be published`)
};

export const publish_kind_chat = /** @type {(inputs: Publish_Kind_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat`)
};

export const publish_kind_member = /** @type {(inputs: Publish_Kind_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Member`)
};

export const publish_kind_message = /** @type {(inputs: Publish_Kind_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message`)
};

export const publish_kind_other = /** @type {(inputs: Publish_Kind_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reference`)
};

export const publish_kind_private_page = /** @type {(inputs: Publish_Kind_Private_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Private document`)
};

export const publish_made_with = /** @type {(inputs: Publish_Made_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Made with trameria`)
};

export const publish_slide_controls = /** @type {(inputs: Publish_Slide_ControlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slide controls`)
};

export const publish_slide_exit_fullscreen = /** @type {(inputs: Publish_Slide_Exit_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exit full screen`)
};

export const publish_slide_fullscreen = /** @type {(inputs: Publish_Slide_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full screen`)
};

export const publish_slide_next = /** @type {(inputs: Publish_Slide_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next slide`)
};

export const publish_slide_prev = /** @type {(inputs: Publish_Slide_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous slide`)
};

export const publish_unavailable = /** @type {(inputs: Publish_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publishing by link is not available here (no public store)`)
};

export const publish_updated_at = /** @type {(inputs: Publish_Updated_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Updated ${i?.date}`)
};

export const push_app_denied = /** @type {(inputs: Push_App_DeniedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Notifications are not allowed in the ${i?.device}'s Settings`)
};

export const push_app_label = /** @type {(inputs: Push_App_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.device} (app)`)
};

export const push_app_open_settings = /** @type {(inputs: Push_App_Open_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Settings`)
};

export const push_blocked = /** @type {(inputs: Push_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications are blocked in this browser. Allow them in the site settings in the address bar, then you can start receiving them here`)
};

export const push_delivered_at = /** @type {(inputs: Push_Delivered_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Last delivered ${i?.when}`)
};

export const push_desktop_app = /** @type {(inputs: Push_Desktop_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desktop app`)
};

export const push_desktop_blocked = /** @type {(inputs: Push_Desktop_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`macOS notifications are not allowed`)
};

export const push_desktop_open_settings = /** @type {(inputs: Push_Desktop_Open_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open System Settings`)
};

export const push_desktop_unsigned = /** @type {(inputs: Push_Desktop_UnsignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This build cannot show macOS notifications`)
};

export const push_destinations = /** @type {(inputs: Push_DestinationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destinations`)
};

export const push_hub_sealed = /** @type {(inputs: Push_Hub_SealedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You have a new notification`)
};

export const push_ios_add_to_home = /** @type {(inputs: Push_Ios_Add_To_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add this app to your Home Screen to get notifications. Use the Share button and choose "Add to Home Screen"`)
};

export const push_not_delivered = /** @type {(inputs: Push_Not_DeliveredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing delivered yet`)
};

export const push_not_sent = /** @type {(inputs: Push_Not_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It could not be delivered`)
};

export const push_other_device = /** @type {(inputs: Push_Other_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other`)
};

export const push_receive = /** @type {(inputs: Push_ReceiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Receive on this device`)
};

export const push_remove = /** @type {(inputs: Push_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

export const push_remove_failed = /** @type {(inputs: Push_Remove_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Couldn't remove "${i?.name}"`)
};

export const push_removed = /** @type {(inputs: Push_RemovedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Removed "${i?.name}"`)
};

export const push_send_test = /** @type {(inputs: Push_Send_TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send test`)
};

export const push_sent = /** @type {(inputs: Push_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sent a test notification`)
};

export const push_subscribe_failed = /** @type {(inputs: Push_Subscribe_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't start receiving notifications`)
};

export const push_test_failed = /** @type {(inputs: Push_Test_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't send the test`)
};

export const push_this_device = /** @type {(inputs: Push_This_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This device`)
};

export const push_unavailable = /** @type {(inputs: Push_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications aren't available in this environment`)
};

export const push_unsubscribe_failed = /** @type {(inputs: Push_Unsubscribe_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't stop receiving notifications`)
};

export const push_unsupported = /** @type {(inputs: Push_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This browser doesn't support notifications`)
};

export const sandboxes_admin_allow = /** @type {(inputs: Sandboxes_Admin_AllowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allow`)
};

export const sandboxes_admin_allow_by_email = /** @type {(inputs: Sandboxes_Admin_Allow_By_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allow by email`)
};

export const sandboxes_admin_allow_by_email_note = /** @type {(inputs: Sandboxes_Admin_Allow_By_Email_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An email address registered on trameria`)
};

export const sandboxes_admin_allow_dev = /** @type {(inputs: Sandboxes_Admin_Allow_DevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allow development`)
};

export const sandboxes_admin_allow_failed = /** @type {(inputs: Sandboxes_Admin_Allow_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't allow`)
};

export const sandboxes_admin_col_allowed = /** @type {(inputs: Sandboxes_Admin_Col_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allowed`)
};

export const sandboxes_admin_col_email = /** @type {(inputs: Sandboxes_Admin_Col_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

export const sandboxes_admin_col_kind = /** @type {(inputs: Sandboxes_Admin_Col_KindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kind`)
};

export const sandboxes_admin_col_state = /** @type {(inputs: Sandboxes_Admin_Col_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`State`)
};

export const sandboxes_admin_description = /** @type {(inputs: Sandboxes_Admin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`People allowed here can make their own trameria cloud. The development one is a sandbox for people who develop, kept apart from the general one. Revoking deletes that kind of trameria cloud too.`)
};

export const sandboxes_admin_email_label = /** @type {(inputs: Sandboxes_Admin_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email address to allow`)
};

export const sandboxes_admin_empty = /** @type {(inputs: Sandboxes_Admin_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nobody is allowed`)
};

export const sandboxes_admin_kind_dev = /** @type {(inputs: Sandboxes_Admin_Kind_DevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Development`)
};

export const sandboxes_admin_kind_general = /** @type {(inputs: Sandboxes_Admin_Kind_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General`)
};

export const sandboxes_admin_last_active = /** @type {(inputs: Sandboxes_Admin_Last_ActiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Last used ${i?.time}`)
};

export const sandboxes_admin_memory_note = /** @type {(inputs: Sandboxes_Admin_Memory_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (the sum of the limits of awake sandboxes; beyond the budget they wait)`)
};

export const sandboxes_admin_memory_usage = /** @type {(inputs: Sandboxes_Admin_Memory_UsageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`In use ${i?.used} GB / budget ${i?.budget} GB`)
};

export const sandboxes_admin_not_created = /** @type {(inputs: Sandboxes_Admin_Not_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not made yet`)
};

export const sandboxes_admin_revoke = /** @type {(inputs: Sandboxes_Admin_RevokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revoke`)
};

export const sandboxes_admin_revoke_confirm_dev = /** @type {(inputs: Sandboxes_Admin_Revoke_Confirm_DevInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Revoke the development allowance of “${i?.label}”. Their trameria cloud, if any, is deleted with its disk (the files in the working directory) and logins. Running previews stop.`)
};

export const sandboxes_admin_revoke_confirm_general = /** @type {(inputs: Sandboxes_Admin_Revoke_Confirm_GeneralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Revoke the general allowance of “${i?.label}”. Their trameria cloud, if any, is deleted with its disk (the files in the working directory) and logins.`)
};

export const sandboxes_admin_revoke_failed_dev = /** @type {(inputs: Sandboxes_Admin_Revoke_Failed_DevInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Couldn't revoke the development allowance of ${i?.email}`)
};

export const sandboxes_admin_revoke_failed_general = /** @type {(inputs: Sandboxes_Admin_Revoke_Failed_GeneralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Couldn't revoke the general allowance of ${i?.email}`)
};

export const sandboxes_admin_revoke_label_dev = /** @type {(inputs: Sandboxes_Admin_Revoke_Label_DevInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Revoke the development allowance of ${i?.email}`)
};

export const sandboxes_admin_revoke_label_general = /** @type {(inputs: Sandboxes_Admin_Revoke_Label_GeneralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Revoke the general allowance of ${i?.email}`)
};

export const sandboxes_admin_revoking_state = /** @type {(inputs: Sandboxes_Admin_Revoking_StateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Revoking · ${i?.state}`)
};

export const sandboxes_admin_title = /** @type {(inputs: Sandboxes_Admin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trameria cloud`)
};

export const sandboxes_error_collision = /** @type {(inputs: Sandboxes_Error_CollisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Another sandbox has the same name, so this one can't be made. Tell the operators`)
};

export const sandboxes_error_delete_timeout = /** @type {(inputs: Sandboxes_Error_Delete_TimeoutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Deleting hasn't finished in ${i?.minutes} minutes. It goes on`)
};

export const sandboxes_error_k8s = /** @type {(inputs: Sandboxes_Error_K8sInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't reach the server's environment. It tries again by itself shortly`)
};

export const sandboxes_error_no_dev_image = /** @type {(inputs: Sandboxes_Error_No_Dev_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No development image is set up. Tell the operators`)
};

export const sandboxes_error_other = /** @type {(inputs: Sandboxes_Error_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unknown cause (${i?.code})`)
};

export const sandboxes_error_profile_mismatch = /** @type {(inputs: Sandboxes_Error_Profile_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A sandbox of the other kind is left over, so this one can't start. Tell the operators`)
};

export const sandboxes_error_start_timeout = /** @type {(inputs: Sandboxes_Error_Start_TimeoutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`It didn't start within ${i?.minutes} minutes. It tries again by itself shortly`)
};

export const sandboxes_error_stop_timeout = /** @type {(inputs: Sandboxes_Error_Stop_TimeoutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`It didn't stop within ${i?.minutes} minutes`)
};

export const sandboxes_error_unreachable = /** @type {(inputs: Sandboxes_Error_UnreachableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`It started, but its agent didn't connect within ${i?.minutes} minutes. It tries again by itself shortly`)
};

export const sandboxes_line_asleep = /** @type {(inputs: Sandboxes_Line_AsleepInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} is asleep. Talking to it wakes it`)
};

export const sandboxes_line_deleting = /** @type {(inputs: Sandboxes_Line_DeletingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Deleting ${i?.name}`)
};

export const sandboxes_line_error = /** @type {(inputs: Sandboxes_Line_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} isn't working. ${i?.error}`)
};

export const sandboxes_line_preparing = /** @type {(inputs: Sandboxes_Line_PreparingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Getting ${i?.name} ready. What you send arrives once it's ready`)
};

export const sandboxes_line_queued = /** @type {(inputs: Sandboxes_Line_QueuedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} is waiting (#${i?.n}) for room on the server and wakes by itself when there is. What you send arrives once it's awake`)
};

export const sandboxes_line_waking = /** @type {(inputs: Sandboxes_Line_WakingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Waking ${i?.name}. What you send arrives once it's awake`)
};

export const sandboxes_menu_previews = /** @type {(inputs: Sandboxes_Menu_PreviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previews`)
};

export const sandboxes_name_dev = /** @type {(inputs: Sandboxes_Name_DevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`the development trameria cloud`)
};

export const sandboxes_name_general = /** @type {(inputs: Sandboxes_Name_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trameria cloud`)
};

export const sandboxes_preview_forbidden = /** @type {(inputs: Sandboxes_Preview_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You may not view this preview.`)
};

export const sandboxes_preview_open_failed = /** @type {(inputs: Sandboxes_Preview_Open_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't open the preview. Wait a moment and open it again.`)
};

export const sandboxes_preview_opening = /** @type {(inputs: Sandboxes_Preview_OpeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opening the preview…`)
};

export const sandboxes_previews_description = /** @type {(inputs: Sandboxes_Previews_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previews running on development trameria clouds. A sleeping sandbox wakes when its owner talks to it or when a preview URL opened before is opened again.`)
};

export const sandboxes_previews_empty = /** @type {(inputs: Sandboxes_Previews_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No development trameria cloud yet`)
};

export const sandboxes_previews_last_seen = /** @type {(inputs: Sandboxes_Previews_Last_SeenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Last viewed ${i?.time}`)
};

export const sandboxes_previews_none_running = /** @type {(inputs: Sandboxes_Previews_None_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No previews running`)
};

export const sandboxes_previews_status_conflict = /** @type {(inputs: Sandboxes_Previews_Status_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Two worktrees make this name`)
};

export const sandboxes_previews_status_failed = /** @type {(inputs: Sandboxes_Previews_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't start`)
};

export const sandboxes_previews_status_missing = /** @type {(inputs: Sandboxes_Previews_Status_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No worktree`)
};

export const sandboxes_previews_status_running = /** @type {(inputs: Sandboxes_Previews_Status_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Running`)
};

export const sandboxes_previews_stop = /** @type {(inputs: Sandboxes_Previews_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop`)
};

export const sandboxes_previews_stop_failed = /** @type {(inputs: Sandboxes_Previews_Stop_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Couldn't stop “${i?.name}”`)
};

export const sandboxes_previews_stop_label = /** @type {(inputs: Sandboxes_Previews_Stop_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stop ${i?.name}`)
};

export const sandboxes_previews_stop_offline = /** @type {(inputs: Sandboxes_Previews_Stop_OfflineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Couldn't stop “${i?.name}”. The sandbox isn't running, so there is nothing to stop`)
};

export const sandboxes_previews_stopping = /** @type {(inputs: Sandboxes_Previews_StoppingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stopping…`)
};

export const sandboxes_previews_title = /** @type {(inputs: Sandboxes_Previews_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previews`)
};

export const sandboxes_status_asleep = /** @type {(inputs: Sandboxes_Status_AsleepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asleep`)
};

export const sandboxes_status_deleting = /** @type {(inputs: Sandboxes_Status_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleting`)
};

export const sandboxes_status_error = /** @type {(inputs: Sandboxes_Status_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not working`)
};

export const sandboxes_status_preparing = /** @type {(inputs: Sandboxes_Status_PreparingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Getting ready`)
};

export const sandboxes_status_queued = /** @type {(inputs: Sandboxes_Status_QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting`)
};

export const sandboxes_status_queued_at = /** @type {(inputs: Sandboxes_Status_Queued_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Waiting · #${i?.n}`)
};

export const sandboxes_status_running = /** @type {(inputs: Sandboxes_Status_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Running`)
};

export const sandboxes_status_waking = /** @type {(inputs: Sandboxes_Status_WakingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waking up`)
};

export const vc_calls = /** @type {(inputs: Vc_CallsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calls`)
};

export const vc_cancel = /** @type {(inputs: Vc_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

export const vc_close_disabled = /** @type {(inputs: Vc_Close_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calls are turned off in this space`)
};

export const vc_close_ended = /** @type {(inputs: Vc_Close_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Call ended`)
};

export const vc_close_full = /** @type {(inputs: Vc_Close_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Call is full (4 people max)`)
};

export const vc_close_not_found = /** @type {(inputs: Vc_Close_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Call not found`)
};

export const vc_close_replaced = /** @type {(inputs: Vc_Close_ReplacedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joined in another tab`)
};

export const vc_closed_rejoin = /** @type {(inputs: Vc_Closed_RejoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disconnected. Join again.`)
};

export const vc_conn_closed = /** @type {(inputs: Vc_Conn_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disconnected`)
};

export const vc_conn_connected = /** @type {(inputs: Vc_Conn_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connected`)
};

export const vc_conn_connecting = /** @type {(inputs: Vc_Conn_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connecting`)
};

export const vc_conn_failed = /** @type {(inputs: Vc_Conn_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can't connect`)
};

export const vc_conn_unstable = /** @type {(inputs: Vc_Conn_UnstableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connection unstable`)
};

export const vc_denoise_loading = /** @type {(inputs: Vc_Denoise_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noise suppression: Preparing…`)
};

export const vc_denoise_off = /** @type {(inputs: Vc_Denoise_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noise suppression: Off`)
};

export const vc_denoise_on = /** @type {(inputs: Vc_Denoise_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noise suppression: On`)
};

export const vc_denoise_unavailable = /** @type {(inputs: Vc_Denoise_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noise suppression isn't available, so your raw microphone audio is being sent.`)
};

export const vc_elapsed = /** @type {(inputs: Vc_ElapsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.elapsed} elapsed`)
};

export const vc_empty = /** @type {(inputs: Vc_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No calls yet`)
};

export const vc_end = /** @type {(inputs: Vc_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End call`)
};

export const vc_end_failed = /** @type {(inputs: Vc_End_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't end the call. Try again.`)
};

export const vc_ended_mark = /** @type {(inputs: Vc_Ended_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ended`)
};

export const vc_ended_sub = /** @type {(inputs: Vc_Ended_SubInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.when} · ${i?.duration} · ${i?.people}`)
};

export const vc_filter = /** @type {(inputs: Vc_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Narrow calls`)
};

export const vc_filter_all = /** @type {(inputs: Vc_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

export const vc_filter_ended = /** @type {(inputs: Vc_Filter_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`History`)
};

export const vc_filter_live = /** @type {(inputs: Vc_Filter_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In call`)
};

export const vc_join = /** @type {(inputs: Vc_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join`)
};

export const vc_join_prepare_failed = /** @type {(inputs: Vc_Join_Prepare_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't prepare the connection. Try again.`)
};

export const vc_joined_aria = /** @type {(inputs: Vc_Joined_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Call you're in: ${i?.title}`)
};

export const vc_leave = /** @type {(inputs: Vc_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave`)
};

export const vc_live_mark = /** @type {(inputs: Vc_Live_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In call`)
};

export const vc_load_failed = /** @type {(inputs: Vc_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't load the calls`)
};

export const vc_mic_denied = /** @type {(inputs: Vc_Mic_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Microphone access is needed. Allow it in your browser settings, then try again.`)
};

export const vc_minutes = /** @type {(inputs: Vc_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min} min`)
};

export const vc_mute = /** @type {(inputs: Vc_MuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mute`)
};

export const vc_muted = /** @type {(inputs: Vc_MutedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muted`)
};

export const vc_narrow = /** @type {(inputs: Vc_NarrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Narrow calls`)
};

export const vc_narrow_title = /** @type {(inputs: Vc_Narrow_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Narrow by title`)
};

export const vc_new_call = /** @type {(inputs: Vc_New_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New call`)
};

export const vc_new_note = /** @type {(inputs: Vc_New_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A throwaway call. Up to 4 people. Audio isn't saved.`)
};

export const vc_no_space = /** @type {(inputs: Vc_No_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No space can have calls`)
};

export const vc_nobody = /** @type {(inputs: Vc_NobodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No one yet`)
};

export const vc_none_match = /** @type {(inputs: Vc_None_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No calls match`)
};

export const vc_not_found = /** @type {(inputs: Vc_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This call can't be found`)
};

export const vc_note_ended = /** @type {(inputs: Vc_Note_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This call has ended. The audio wasn't saved.`)
};

export const vc_note_live = /** @type {(inputs: Vc_Note_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A throwaway call. It disappears when closed. Write down anything you want to keep in a Topic.`)
};

export const vc_own_screen = /** @type {(inputs: Vc_Own_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your screen (this is what others see)`)
};

export const vc_people = /** @type {(inputs: Vc_PeopleInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} person`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} people`);
	return /** @type {LocalizedString} */ ("vc_people");
};

export const vc_play_audio = /** @type {(inputs: Vc_Play_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play audio`)
};

export const vc_reconnecting = /** @type {(inputs: Vc_ReconnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reconnecting`)
};

export const vc_screen_of = /** @type {(inputs: Vc_Screen_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}'s screen`)
};

export const vc_self_suffix = /** @type {(inputs: Vc_Self_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(you)`)
};

export const vc_share_screen = /** @type {(inputs: Vc_Share_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share screen`)
};

export const vc_sharing = /** @type {(inputs: Vc_SharingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sharing screen`)
};

export const vc_space_label = /** @type {(inputs: Vc_Space_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Space`)
};

export const vc_start = /** @type {(inputs: Vc_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start call`)
};

export const vc_start_failed = /** @type {(inputs: Vc_Start_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't start the call. Try again.`)
};

export const vc_stop_sharing = /** @type {(inputs: Vc_Stop_SharingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop sharing`)
};

export const vc_title_aria = /** @type {(inputs: Vc_Title_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Call title`)
};

export const vc_title_label = /** @type {(inputs: Vc_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

export const vc_title_placeholder = /** @type {(inputs: Vc_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What's it about?`)
};

export const vc_to_list = /** @type {(inputs: Vc_To_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to list`)
};

export const vc_unknown_member = /** @type {(inputs: Vc_Unknown_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Former member`)
};

export const vc_unmute = /** @type {(inputs: Vc_UnmuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unmute`)
};

export const vc_waiting_video = /** @type {(inputs: Vc_Waiting_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting for video`)
};

export const wd_col_space = /** @type {(inputs: Wd_Col_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Space`)
};

export const wd_datasets = /** @type {(inputs: Wd_DatasetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dataset`)
};

export const wd_datasets_back = /** @type {(inputs: Wd_Datasets_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to Documents`)
};

export const wd_datasets_create = /** @type {(inputs: Wd_Datasets_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create`)
};

export const wd_datasets_create_failed = /** @type {(inputs: Wd_Datasets_Create_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't create the dataset`)
};

export const wd_datasets_empty = /** @type {(inputs: Wd_Datasets_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No datasets yet.`)
};

export const wd_datasets_load_failed = /** @type {(inputs: Wd_Datasets_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't load the datasets`)
};

export const wd_datasets_new = /** @type {(inputs: Wd_Datasets_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New dataset`)
};

export const wd_datasets_new_note = /** @type {(inputs: Wd_Datasets_New_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keeps the JSON rows that scripts and agents send. Fields are guessed from the rows received; ask an agent to set fields or a retention period ahead.`)
};

export const wd_datasets_none_match = /** @type {(inputs: Wd_Datasets_None_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No datasets match.`)
};

export const wd_datasets_rows = /** @type {(inputs: Wd_Datasets_RowsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} rows`)
};

export const wd_datasets_space = /** @type {(inputs: Wd_Datasets_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Space`)
};

export const wd_datasets_space_empty = /** @type {(inputs: Wd_Datasets_Space_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No datasets yet.`)
};

export const wd_datasets_title = /** @type {(inputs: Wd_Datasets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

export const wd_empty = /** @type {(inputs: Wd_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No documents yet.`)
};

export const wd_load_failed = /** @type {(inputs: Wd_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not load the documents`)
};

export const wd_move_failed = /** @type {(inputs: Wd_Move_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not move “${i?.title}”`)
};

export const wd_move_hint = /** @type {(inputs: Wd_Move_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only those who see the space it moves to will see it.`)
};

export const wd_move_title = /** @type {(inputs: Wd_Move_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Move “${i?.title}” to another space`)
};

export const wd_nav = /** @type {(inputs: Wd_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documents`)
};

export const wd_new_in = /** @type {(inputs: Wd_New_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Space to make it in`)
};

export const wd_no_space = /** @type {(inputs: Wd_No_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No space can hold documents.`)
};

export const wd_none_match = /** @type {(inputs: Wd_None_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No documents match.`)
};

export const wd_pin_failed = /** @type {(inputs: Wd_Pin_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not change the pin of “${i?.title}”`)
};

export const wd_release = /** @type {(inputs: Wd_ReleaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move to a workspace`)
};

export const wd_release_action = /** @type {(inputs: Wd_Release_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move`)
};

export const wd_release_body = /** @type {(inputs: Wd_Release_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Once moved, those who see the chosen space can read it and those who may write documents in the workspace can write it. It leaves your indexes and its public link stops. This cannot be undone (make a copy first to keep one of your own).`)
};

export const wd_release_failed = /** @type {(inputs: Wd_Release_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not move “${i?.title}”`)
};

export const wd_release_no_space = /** @type {(inputs: Wd_Release_No_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This workspace has no space where you can write documents.`)
};

export const wd_release_none = /** @type {(inputs: Wd_Release_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No workspace to move it to.`)
};

export const wd_release_space = /** @type {(inputs: Wd_Release_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Space`)
};

export const wd_release_title = /** @type {(inputs: Wd_Release_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Move “${i?.title}” to a workspace`)
};

export const wd_release_workspace = /** @type {(inputs: Wd_Release_WorkspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace`)
};

export const wd_released = /** @type {(inputs: Wd_ReleasedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Moved “${i?.title}” to ${i?.workspace}`)
};

export const wd_space_empty = /** @type {(inputs: Wd_Space_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No documents yet.`)
};

export const web_admin_description = /** @type {(inputs: Web_Admin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pages only for the people who run trameria.`)
};

export const web_admin_title = /** @type {(inputs: Web_Admin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin`)
};

export const web_admin_waitlist_approve = /** @type {(inputs: Web_Admin_Waitlist_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approve`)
};

export const web_admin_waitlist_approve_failed = /** @type {(inputs: Web_Admin_Waitlist_Approve_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't approve`)
};

export const web_admin_waitlist_approved_done = /** @type {(inputs: Web_Admin_Waitlist_Approved_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Approved ${i?.count} and mailed them`)
};

export const web_admin_waitlist_clear = /** @type {(inputs: Web_Admin_Waitlist_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear selection`)
};

export const web_admin_waitlist_col_email = /** @type {(inputs: Web_Admin_Waitlist_Col_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

export const web_admin_waitlist_col_joined = /** @type {(inputs: Web_Admin_Waitlist_Col_JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joined`)
};

export const web_admin_waitlist_col_via = /** @type {(inputs: Web_Admin_Waitlist_Col_ViaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Via`)
};

export const web_admin_waitlist_confirm_approve = /** @type {(inputs: Web_Admin_Waitlist_Confirm_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approve`)
};

export const web_admin_waitlist_confirm_text = /** @type {(inputs: Web_Admin_Waitlist_Confirm_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This mails ${i?.count} people that they can sign in`)
};

export const web_admin_waitlist_description = /** @type {(inputs: Web_Admin_Waitlist_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approving mails the person that they can now sign in.`)
};

export const web_admin_waitlist_empty = /** @type {(inputs: Web_Admin_Waitlist_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nobody is waiting`)
};

export const web_admin_waitlist_select_all = /** @type {(inputs: Web_Admin_Waitlist_Select_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select all`)
};

export const web_admin_waitlist_selected = /** @type {(inputs: Web_Admin_Waitlist_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} selected`)
};

export const web_admin_waitlist_title = /** @type {(inputs: Web_Admin_Waitlist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waitlist`)
};

export const web_admin_waitlist_toolbar = /** @type {(inputs: Web_Admin_Waitlist_ToolbarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions for the selection`)
};

export const web_admin_waitlist_via_email = /** @type {(inputs: Web_Admin_Waitlist_Via_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

export const web_app_update_load = /** @type {(inputs: Web_App_Update_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load the new version`)
};

export const web_banned = /** @type {(inputs: Web_BannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This account has been suspended. If you don't know why, contact the operator`)
};

export const web_captcha_failed = /** @type {(inputs: Web_Captcha_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The check failed. Try again`)
};

export const web_home_icon = /** @type {(inputs: Web_Home_IconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Home screen icon`)
};

export const web_home_icon_black = /** @type {(inputs: Web_Home_Icon_BlackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Black`)
};

export const web_home_icon_green = /** @type {(inputs: Web_Home_Icon_GreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Green`)
};

export const web_home_icon_ground_black = /** @type {(inputs: Web_Home_Icon_Ground_BlackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Black ground`)
};

export const web_home_icon_ground_white = /** @type {(inputs: Web_Home_Icon_Ground_WhiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`White ground`)
};

export const web_home_icon_ink = /** @type {(inputs: Web_Home_Icon_InkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ink`)
};

export const web_home_icon_note = /** @type {(inputs: Web_Home_Icon_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The color and ground used when you add trameria to your home screen. Saved in this browser. Icons already added don't change; add it again after switching.`)
};

export const web_home_icon_purple = /** @type {(inputs: Web_Home_Icon_PurpleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purple`)
};

export const web_home_icon_standard = /** @type {(inputs: Web_Home_Icon_StandardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard`)
};

export const web_home_icon_vermilion = /** @type {(inputs: Web_Home_Icon_VermilionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vermilion`)
};

export const web_home_icon_white = /** @type {(inputs: Web_Home_Icon_WhiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`White`)
};

export const web_hub_allow = /** @type {(inputs: Web_Hub_AllowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link`)
};

export const web_hub_code_label = /** @type {(inputs: Web_Hub_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The code your Vault or PC shows`)
};

export const web_hub_code_next = /** @type {(inputs: Web_Hub_Code_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue`)
};

export const web_hub_connecting = /** @type {(inputs: Web_Hub_ConnectingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The Vault (${i?.name}) asks to be linked to this account.`)
};

export const web_hub_denied = /** @type {(inputs: Web_Hub_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denied. The Vault is not linked.`)
};

export const web_hub_deny = /** @type {(inputs: Web_Hub_DenyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deny`)
};

export const web_hub_desktop_connecting = /** @type {(inputs: Web_Hub_Desktop_ConnectingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The PC “${i?.name}” asks to be linked to this account.`)
};

export const web_hub_desktop_denied = /** @type {(inputs: Web_Hub_Desktop_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denied. The PC is not linked.`)
};

export const web_hub_desktop_done = /** @type {(inputs: Web_Hub_Desktop_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linked. Go back to your PC.`)
};

export const web_hub_desktop_what = /** @type {(inputs: Web_Hub_Desktop_WhatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Once linked, this PC can use this account's Cloud by itself, until it signs out there.`)
};

export const web_hub_done = /** @type {(inputs: Web_Hub_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linked. Go back to your Vault.`)
};

export const web_hub_failed = /** @type {(inputs: Web_Hub_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not link`)
};

export const web_hub_not_found = /** @type {(inputs: Web_Hub_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The code was not found or has expired. Start again on the Vault or PC.`)
};

export const web_hub_pair_pc = /** @type {(inputs: Web_Hub_Pair_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On a PC, enter the code shown on the Vault's screen in Trameria's "Join a Vault".`)
};

export const web_hub_pair_phone = /** @type {(inputs: Web_Hub_Pair_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On iPhone and iPad this opens in the Trameria app. If the app didn't open, install it and scan the QR code again.`)
};

export const web_hub_pair_title = /** @type {(inputs: Web_Hub_Pair_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect to a Vault`)
};

export const web_hub_started_at = /** @type {(inputs: Web_Hub_Started_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Started: ${i?.time}`)
};

export const web_hub_started_from = /** @type {(inputs: Web_Hub_Started_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`From: ${i?.place}`)
};

export const web_hub_title = /** @type {(inputs: Web_Hub_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link to your account`)
};

export const web_hub_type_code = /** @type {(inputs: Web_Hub_Type_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This link was started somewhere other than the network you are on now. If you started it yourself, enter the code your Vault or PC shows.`)
};

export const web_hub_warning = /** @type {(inputs: Web_Hub_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don't link it unless you started this yourself`)
};

export const web_hub_what = /** @type {(inputs: Web_Hub_WhatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Once linked, this account owns the Vault. Until it is unlinked on the Vault, it cannot be linked to another account.`)
};

export const web_load_failed = /** @type {(inputs: Web_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't load`)
};

export const web_mail_failed = /** @type {(inputs: Web_Mail_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't send the mail. Try again later`)
};

export const web_me_moving_body = /** @type {(inputs: Web_Me_Moving_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal data is moving between the cloud and the Vault. Until it is done, personal data cannot be opened here. The workspaces work as before.`)
};

export const web_me_moving_open_here = /** @type {(inputs: Web_Me_Moving_Open_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open this PC's screen`)
};

export const web_me_moving_title = /** @type {(inputs: Web_Me_Moving_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal data is moving`)
};

export const web_me_on_hub_body = /** @type {(inputs: Web_Me_On_Hub_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Personal data lives on the Vault (${i?.hub}). Open it in a desktop connected to the Vault. The workspaces work here as before.`)
};

export const web_me_on_hub_body_unnamed = /** @type {(inputs: Web_Me_On_Hub_Body_UnnamedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal data lives on the Vault. Open it in a desktop connected to the Vault. The workspaces work here as before.`)
};

export const web_me_on_hub_title = /** @type {(inputs: Web_Me_On_Hub_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal data lives on the Vault`)
};

export const web_me_opening_here = /** @type {(inputs: Web_Me_Opening_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your personal data is on your Vault. Opening this PC's screen…`)
};

export const web_menu_admin = /** @type {(inputs: Web_Menu_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin`)
};

export const web_menu_sign_out = /** @type {(inputs: Web_Menu_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign out`)
};

export const web_oauth_allow = /** @type {(inputs: Web_Oauth_AllowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allow`)
};

export const web_oauth_can_do = /** @type {(inputs: Web_Oauth_Can_DoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It will be able to`)
};

export const web_oauth_connecting = /** @type {(inputs: Web_Oauth_ConnectingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.client} wants to connect to trameria.`)
};

export const web_oauth_deny = /** @type {(inputs: Web_Oauth_DenyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deny`)
};

export const web_oauth_desktop_warning = /** @type {(inputs: Web_Oauth_Desktop_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don't allow this unless you opened the app yourself`)
};

export const web_oauth_destination = /** @type {(inputs: Web_Oauth_DestinationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Access goes to: ${i?.where}`)
};

export const web_oauth_failed = /** @type {(inputs: Web_Oauth_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't allow the connection`)
};

export const web_oauth_outside_flow = /** @type {(inputs: Web_Oauth_Outside_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This page opens when an MCP client (claude.ai, Claude Code) starts connecting to trameria.`)
};

export const web_oauth_scope_desktop = /** @type {(inputs: Web_Oauth_Scope_DesktopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Let the app on this computer or phone sign in to trameria as you`)
};

export const web_oauth_scope_offline = /** @type {(inputs: Web_Oauth_Scope_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stay connected (even after you sign out, until you disconnect it in Settings → Connected apps)`)
};

export const web_oauth_scope_read = /** @type {(inputs: Web_Oauth_Scope_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read (Cases, People, documents)`)
};

export const web_oauth_scope_write = /** @type {(inputs: Web_Oauth_Scope_WriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write (create and update Cases, People, documents)`)
};

export const web_oauth_this_device = /** @type {(inputs: Web_Oauth_This_DeviceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`an app on this device (${i?.where})`)
};

export const web_oauth_title = /** @type {(inputs: Web_Oauth_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allow the connection`)
};

export const web_oauth_unverified = /** @type {(inputs: Web_Oauth_UnverifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unverified app. It chose its own name, and trameria has not checked it. Deny it unless you recognise where the access goes.`)
};

export const web_otp_expired = /** @type {(inputs: Web_Otp_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The code has expired. Send a new one`)
};

export const web_otp_invalid = /** @type {(inputs: Web_Otp_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That code is wrong`)
};

export const web_otp_too_many = /** @type {(inputs: Web_Otp_Too_ManyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too many tries. Send a new code`)
};

export const web_passkey_failed = /** @type {(inputs: Web_Passkey_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't sign in with a passkey`)
};

export const web_passkey_later = /** @type {(inputs: Web_Passkey_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Later`)
};

export const web_passkey_later_note = /** @type {(inputs: Web_Passkey_Later_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can also add one later in Settings → Sign-in and security.`)
};

export const web_passkey_lead = /** @type {(inputs: Web_Passkey_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next time, sign in with just your fingerprint, face or PIN.`)
};

export const web_passkey_none = /** @type {(inputs: Web_Passkey_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This device has no passkey yet. Continue with your email`)
};

export const web_passkey_register = /** @type {(inputs: Web_Passkey_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add`)
};

export const web_passkey_register_failed = /** @type {(inputs: Web_Passkey_Register_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't add the passkey`)
};

export const web_passkey_title = /** @type {(inputs: Web_Passkey_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a passkey`)
};

export const web_rate_limited = /** @type {(inputs: Web_Rate_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wait a moment and try again`)
};

export const web_resend_too_soon = /** @type {(inputs: Web_Resend_Too_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too soon to send again`)
};

export const web_retry = /** @type {(inputs: Web_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

export const web_settings_apps = /** @type {(inputs: Web_Settings_AppsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connected apps`)
};

export const web_settings_apps_allow_workspace = /** @type {(inputs: Web_Settings_Apps_Allow_WorkspaceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Allow connected apps in ${i?.name}`)
};

export const web_settings_apps_app_description = /** @type {(inputs: Web_Settings_Apps_App_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.scopes} · allowed ${i?.granted}`)
};

export const web_settings_apps_copied = /** @type {(inputs: Web_Settings_Apps_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copied`)
};

export const web_settings_apps_copy = /** @type {(inputs: Web_Settings_Apps_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy`)
};

export const web_settings_apps_description = /** @type {(inputs: Web_Settings_Apps_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apps outside trameria (Claude and others) that use it for you.`)
};

export const web_settings_apps_disconnect = /** @type {(inputs: Web_Settings_Apps_DisconnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disconnect`)
};

export const web_settings_apps_disconnect_body = /** @type {(inputs: Web_Settings_Apps_Disconnect_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Its next call will be refused. To use it again, connect again from the app.`)
};

export const web_settings_apps_disconnect_failed = /** @type {(inputs: Web_Settings_Apps_Disconnect_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Couldn't disconnect "${i?.name}"`)
};

export const web_settings_apps_disconnect_title = /** @type {(inputs: Web_Settings_Apps_Disconnect_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Disconnect "${i?.name}"`)
};

export const web_settings_apps_empty = /** @type {(inputs: Web_Settings_Apps_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No app is connected.`)
};

export const web_settings_apps_list = /** @type {(inputs: Web_Settings_Apps_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apps`)
};

export const web_settings_apps_no_workspaces = /** @type {(inputs: Web_Settings_Apps_No_WorkspacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are not in any workspace.`)
};

export const web_settings_apps_not_allowed = /** @type {(inputs: Web_Settings_Apps_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An admin of this workspace has not allowed MCP`)
};

export const web_settings_apps_scope_desktop = /** @type {(inputs: Web_Settings_Apps_Scope_DesktopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desktop app`)
};

export const web_settings_apps_scope_offline = /** @type {(inputs: Web_Settings_Apps_Scope_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stay connected`)
};

export const web_settings_apps_scope_read = /** @type {(inputs: Web_Settings_Apps_Scope_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read`)
};

export const web_settings_apps_scope_write = /** @type {(inputs: Web_Settings_Apps_Scope_WriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write`)
};

export const web_settings_apps_url = /** @type {(inputs: Web_Settings_Apps_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Server URL`)
};

export const web_settings_apps_url_note = /** @type {(inputs: Web_Settings_Apps_Url_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste this URL when adding a connector in Claude.`)
};

export const web_settings_apps_workspace_failed = /** @type {(inputs: Web_Settings_Apps_Workspace_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not change access to ${i?.name}`)
};

export const web_settings_apps_workspaces = /** @type {(inputs: Web_Settings_Apps_WorkspacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspaces`)
};

export const web_settings_apps_workspaces_note = /** @type {(inputs: Web_Settings_Apps_Workspaces_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connected apps can read and write only the workspaces you allow.`)
};

export const web_settings_description = /** @type {(inputs: Web_Settings_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your personal settings, shared across all Workspaces.`)
};

export const web_settings_security = /** @type {(inputs: Web_Settings_SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign-in and security`)
};

export const web_settings_security_add = /** @type {(inputs: Web_Settings_Security_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a passkey`)
};

export const web_settings_security_add_failed = /** @type {(inputs: Web_Settings_Security_Add_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't add the passkey`)
};

export const web_settings_security_delete_body = /** @type {(inputs: Web_Settings_Security_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You won't be able to sign in with this passkey any more.`)
};

export const web_settings_security_delete_failed = /** @type {(inputs: Web_Settings_Security_Delete_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Couldn't delete "${i?.name}"`)
};

export const web_settings_security_delete_last_body = /** @type {(inputs: Web_Settings_Security_Delete_Last_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is your last passkey. Without it, you'll sign in with a code by mail.`)
};

export const web_settings_security_delete_named = /** @type {(inputs: Web_Settings_Security_Delete_NamedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete ${i?.name}`)
};

export const web_settings_security_delete_title = /** @type {(inputs: Web_Settings_Security_Delete_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete the passkey "${i?.name}"`)
};

export const web_settings_security_description = /** @type {(inputs: Web_Settings_Security_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How you sign in. With a passkey you don't need to type a code.`)
};

export const web_settings_security_email = /** @type {(inputs: Web_Settings_Security_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

export const web_settings_security_email_note = /** @type {(inputs: Web_Settings_Security_Email_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where sign-in codes go.`)
};

export const web_settings_security_google = /** @type {(inputs: Web_Settings_Security_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google`)
};

export const web_settings_security_google_link = /** @type {(inputs: Web_Settings_Security_Google_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link`)
};

export const web_settings_security_google_link_failed = /** @type {(inputs: Web_Settings_Security_Google_Link_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't link Google`)
};

export const web_settings_security_google_linked = /** @type {(inputs: Web_Settings_Security_Google_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linked`)
};

export const web_settings_security_google_not_configured = /** @type {(inputs: Web_Settings_Security_Google_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not available here`)
};

export const web_settings_security_google_note = /** @type {(inputs: Web_Settings_Security_Google_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Also sign in with your Google account.`)
};

export const web_settings_security_passkeys = /** @type {(inputs: Web_Settings_Security_PasskeysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passkeys`)
};

export const web_settings_security_passkeys_note = /** @type {(inputs: Web_Settings_Security_Passkeys_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passkeys kept on your devices or in a password manager.`)
};

export const web_settings_security_registered_on = /** @type {(inputs: Web_Settings_Security_Registered_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Added ${i?.date}`)
};

export const web_settings_security_unnamed = /** @type {(inputs: Web_Settings_Security_UnnamedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unnamed`)
};

export const web_settings_title = /** @type {(inputs: Web_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account settings`)
};

export const web_signin_code_label = /** @type {(inputs: Web_Signin_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code`)
};

export const web_signin_code_reused = /** @type {(inputs: Web_Signin_Code_ReusedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The code we sent to ${i?.email} a moment ago still works. It works for ${i?.minutes} minutes.`)
};

export const web_signin_code_sent = /** @type {(inputs: Web_Signin_Code_SentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`We sent a 6-digit code to ${i?.email}. It works for ${i?.minutes} minutes.`)
};

export const web_signin_continue = /** @type {(inputs: Web_Signin_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue`)
};

export const web_signin_email_hint = /** @type {(inputs: Web_Signin_Email_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We'll email you a 6-digit code`)
};

export const web_signin_email_invalid = /** @type {(inputs: Web_Signin_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That doesn't look like an email address`)
};

export const web_signin_email_label = /** @type {(inputs: Web_Signin_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

export const web_signin_failed = /** @type {(inputs: Web_Signin_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't sign in`)
};

export const web_signin_google = /** @type {(inputs: Web_Signin_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue with Google`)
};

export const web_signin_google_failed = /** @type {(inputs: Web_Signin_Google_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't start signing in with Google`)
};

export const web_signin_in_app_body = /** @type {(inputs: Web_Signin_In_App_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in again under Cloud in the app's settings. You sign in in your browser.`)
};

export const web_signin_in_app_title = /** @type {(inputs: Web_Signin_In_App_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signed out of the cloud`)
};

export const web_signin_other_email = /** @type {(inputs: Web_Signin_Other_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use another email`)
};

export const web_signin_passkey = /** @type {(inputs: Web_Signin_PasskeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in with a passkey`)
};

export const web_signin_resend = /** @type {(inputs: Web_Signin_ResendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resend code`)
};

export const web_signin_resent = /** @type {(inputs: Web_Signin_ResentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sent again`)
};

export const web_signin_retry = /** @type {(inputs: Web_Signin_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't sign in. Wait a moment and try again`)
};

export const web_signin_title = /** @type {(inputs: Web_Signin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in`)
};

export const web_trust_approve_pc = /** @type {(inputs: Web_Trust_Approve_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On a PC, enter the code shown under the QR code in "Add a device" under "Device list" in Trameria's app settings.`)
};

export const web_trust_approve_phone = /** @type {(inputs: Web_Trust_Approve_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On iPhone and iPad this opens in the Trameria app. If the app didn't open, install it and scan the QR code again.`)
};

export const web_trust_approve_title = /** @type {(inputs: Web_Trust_Approve_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add to the device list`)
};

export const web_waitlist_body = /** @type {(inputs: Web_Waitlist_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You're on the waitlist. We'll email ${i?.email} once you're approved. When the mail arrives, come back to this page to go on.`)
};

export const web_waitlist_switch = /** @type {(inputs: Web_Waitlist_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in with another account`)
};

export const web_waitlist_title = /** @type {(inputs: Web_Waitlist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waitlist`)
};

export const workspace_default_role_admin = /** @type {(inputs: Workspace_Default_Role_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin`)
};

export const workspace_default_space_name = /** @type {(inputs: Workspace_Default_Space_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General`)
};

export const workspace_unnamed_member = /** @type {(inputs: Workspace_Unnamed_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unnamed`)
};

export const ws_cancel = /** @type {(inputs: Ws_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

export const ws_case_panel = /** @type {(inputs: Ws_Case_PanelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case`)
};

export const ws_delete = /** @type {(inputs: Ws_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

export const ws_dock_spaces = /** @type {(inputs: Ws_Dock_SpacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spaces`)
};

export const ws_feature_broadcast = /** @type {(inputs: Ws_Feature_BroadcastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Broadcast`)
};

export const ws_feature_broadcast_note = /** @type {(inputs: Ws_Feature_Broadcast_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Announcements that reach everyone`)
};

export const ws_feature_cycle = /** @type {(inputs: Ws_Feature_CycleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cycles`)
};

export const ws_feature_cycle_note = /** @type {(inputs: Ws_Feature_Cycle_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Periods that group issues`)
};

export const ws_feature_dm = /** @type {(inputs: Ws_Feature_DmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DM`)
};

export const ws_feature_dm_note = /** @type {(inputs: Ws_Feature_Dm_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One-to-one talks`)
};

export const ws_feature_document = /** @type {(inputs: Ws_Feature_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documents`)
};

export const ws_feature_document_note = /** @type {(inputs: Ws_Feature_Document_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documents written together`)
};

export const ws_feature_issue = /** @type {(inputs: Ws_Feature_IssueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issues`)
};

export const ws_feature_issue_note = /** @type {(inputs: Ws_Feature_Issue_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Single tasks`)
};

export const ws_feature_journal = /** @type {(inputs: Ws_Feature_JournalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Journal`)
};

export const ws_feature_journal_note = /** @type {(inputs: Ws_Feature_Journal_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A timeline per person`)
};

export const ws_feature_project = /** @type {(inputs: Ws_Feature_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projects`)
};

export const ws_feature_project_note = /** @type {(inputs: Ws_Feature_Project_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Larger pieces of work`)
};

export const ws_feature_requires = /** @type {(inputs: Ws_Feature_RequiresInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Needs ${i?.feature}`)
};

export const ws_feature_topic = /** @type {(inputs: Ws_Feature_TopicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversations`)
};

export const ws_feature_topic_note = /** @type {(inputs: Ws_Feature_Topic_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The space's conversations`)
};

export const ws_feature_voice = /** @type {(inputs: Ws_Feature_VoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calls`)
};

export const ws_feature_voice_note = /** @type {(inputs: Ws_Feature_Voice_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calls on the spot`)
};

export const ws_features_enabled = /** @type {(inputs: Ws_Features_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Features in use`)
};

export const ws_features_mcp = /** @type {(inputs: Ws_Features_McpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allow MCP from apps outside`)
};

export const ws_features_mcp_note = /** @type {(inputs: Ws_Features_Mcp_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When off, members cannot read or write this workspace from apps outside. Agents on their devices are not affected`)
};

export const ws_features_outside = /** @type {(inputs: Ws_Features_OutsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From outside`)
};

export const ws_features_publish = /** @type {(inputs: Ws_Features_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allow publishing by link`)
};

export const ws_features_publish_note = /** @type {(inputs: Ws_Features_Publish_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anyone with the link can read a published document`)
};

export const ws_features_publish_off = /** @type {(inputs: Ws_Features_Publish_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn off`)
};

export const ws_features_publish_off_body = /** @type {(inputs: Ws_Features_Publish_Off_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every published document stops, and its link no longer opens. Turning it on again does not bring them back.`)
};

export const ws_features_publish_off_title = /** @type {(inputs: Ws_Features_Publish_Off_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Turn off publishing by link in ${i?.name}?`)
};

export const ws_general_icon = /** @type {(inputs: Ws_General_IconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Icon`)
};

export const ws_general_icon_note = /** @type {(inputs: Ws_General_Icon_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The picture for this workspace on the rail and in menus. Without one, the first letter of its name shows`)
};

export const ws_general_name = /** @type {(inputs: Ws_General_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

export const ws_general_url = /** @type {(inputs: Ws_General_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL`)
};

export const ws_general_url_change = /** @type {(inputs: Ws_General_Url_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change`)
};

export const ws_general_url_edit = /** @type {(inputs: Ws_General_Url_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change`)
};

export const ws_general_url_edit_title = /** @type {(inputs: Ws_General_Url_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change the URL`)
};

export const ws_general_url_note = /** @type {(inputs: Ws_General_Url_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Links with the old URL stop working once it changes`)
};

export const ws_home_empty = /** @type {(inputs: Ws_Home_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversations, documents, issues and calls show up in the sidebar as each of them arrives. Your own Cases open from Cases.`)
};

export const ws_invite_failed = /** @type {(inputs: Ws_Invite_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not join`)
};

export const ws_invite_guest_note = /** @type {(inputs: Ws_Invite_Guest_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You join as a ${i?.kind}. You see only spaces open to everyone and the spaces you join.`)
};

export const ws_invite_join = /** @type {(inputs: Ws_Invite_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join`)
};

export const ws_invite_loading = /** @type {(inputs: Ws_Invite_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading`)
};

export const ws_invite_not_found = /** @type {(inputs: Ws_Invite_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This invite link was not found.`)
};

export const ws_invite_sign_in = /** @type {(inputs: Ws_Invite_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to join`)
};

export const ws_invite_title = /** @type {(inputs: Ws_Invite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite`)
};

export const ws_invite_to = /** @type {(inputs: Ws_Invite_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You are invited to ${i?.workspace}.`)
};

export const ws_invite_unusable = /** @type {(inputs: Ws_Invite_UnusableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This invite link to ${i?.workspace} has expired, been revoked or used up. Ask the person who invited you for a new one.`)
};

export const ws_invites_active = /** @type {(inputs: Ws_Invites_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active`)
};

export const ws_invites_all = /** @type {(inputs: Ws_Invites_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

export const ws_invites_copied = /** @type {(inputs: Ws_Invites_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copied`)
};

export const ws_invites_copy = /** @type {(inputs: Ws_Invites_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy`)
};

export const ws_invites_copy_failed = /** @type {(inputs: Ws_Invites_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not copy. Select the link and copy it`)
};

export const ws_invites_create = /** @type {(inputs: Ws_Invites_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make the link`)
};

export const ws_invites_create_failed = /** @type {(inputs: Ws_Invites_Create_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not make the link`)
};

export const ws_invites_days = /** @type {(inputs: Ws_Invites_DaysInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`For ${i?.count} day`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`For ${i?.count} days`);
	return /** @type {LocalizedString} */ ("ws_invites_days");
};

export const ws_invites_empty = /** @type {(inputs: Ws_Invites_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No links yet`)
};

export const ws_invites_expired = /** @type {(inputs: Ws_Invites_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expired`)
};

export const ws_invites_expires = /** @type {(inputs: Ws_Invites_ExpiresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expires`)
};

export const ws_invites_filter = /** @type {(inputs: Ws_Invites_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter the invite links`)
};

export const ws_invites_guest_note = /** @type {(inputs: Ws_Invites_Guest_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joins as a guest, seeing only spaces open to everyone and the spaces they join. No roles.`)
};

export const ws_invites_joins_as = /** @type {(inputs: Ws_Invites_Joins_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joins as`)
};

export const ws_invites_kind = /** @type {(inputs: Ws_Invites_KindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joins as`)
};

export const ws_invites_link = /** @type {(inputs: Ws_Invites_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite link`)
};

export const ws_invites_list = /** @type {(inputs: Ws_Invites_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite links`)
};

export const ws_invites_max_uses = /** @type {(inputs: Ws_Invites_Max_UsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uses`)
};

export const ws_invites_member_note = /** @type {(inputs: Ws_Invites_Member_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joins as a member, with the permissions of @everyone and the role you choose.`)
};

export const ws_invites_never = /** @type {(inputs: Ws_Invites_NeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Never`)
};

export const ws_invites_new = /** @type {(inputs: Ws_Invites_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New invite link`)
};

export const ws_invites_no_active = /** @type {(inputs: Ws_Invites_No_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No active links`)
};

export const ws_invites_not_found = /** @type {(inputs: Ws_Invites_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This link was not found`)
};

export const ws_invites_revoke = /** @type {(inputs: Ws_Invites_RevokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revoke`)
};

export const ws_invites_revoke_failed = /** @type {(inputs: Ws_Invites_Revoke_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not revoke the link`)
};

export const ws_invites_revoke_note = /** @type {(inputs: Ws_Invites_Revoke_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No one can join with this link any more`)
};

export const ws_invites_revoked = /** @type {(inputs: Ws_Invites_RevokedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revoked`)
};

export const ws_invites_role = /** @type {(inputs: Ws_Invites_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role`)
};

export const ws_invites_role_note = /** @type {(inputs: Ws_Invites_Role_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roles below your own highest role`)
};

export const ws_invites_times = /** @type {(inputs: Ws_Invites_TimesInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Once`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Up to ${i?.count} times`);
	return /** @type {LocalizedString} */ ("ws_invites_times");
};

export const ws_invites_unlimited = /** @type {(inputs: Ws_Invites_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No limit`)
};

export const ws_invites_until = /** @type {(inputs: Ws_Invites_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Until ${i?.date}`)
};

export const ws_invites_url = /** @type {(inputs: Ws_Invites_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link`)
};

export const ws_invites_url_hidden = /** @type {(inputs: Ws_Invites_Url_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This link gives a role you cannot give, so only the person who made it and the owner can see it`)
};

export const ws_invites_url_note = /** @type {(inputs: Ws_Invites_Url_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Whoever gets this link can join`)
};

export const ws_invites_usage = /** @type {(inputs: Ws_Invites_UsageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Used ${i?.used} / ${i?.max}`)
};

export const ws_invites_usage_unlimited = /** @type {(inputs: Ws_Invites_Usage_UnlimitedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Used ${i?.used} / unlimited`)
};

export const ws_invites_used_up = /** @type {(inputs: Ws_Invites_Used_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Used up`)
};

export const ws_invites_uses = /** @type {(inputs: Ws_Invites_UsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uses`)
};

export const ws_invites_uses_of = /** @type {(inputs: Ws_Invites_Uses_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used} / ${i?.max}`)
};

export const ws_invites_uses_unlimited = /** @type {(inputs: Ws_Invites_Uses_UnlimitedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used} / no limit`)
};

export const ws_invites_valid = /** @type {(inputs: Ws_Invites_ValidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usable`)
};

export const ws_kind_guest = /** @type {(inputs: Ws_Kind_GuestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guest`)
};

export const ws_kind_member = /** @type {(inputs: Ws_Kind_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Member`)
};

export const ws_list_narrow = /** @type {(inputs: Ws_List_NarrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Narrow the list`)
};

export const ws_list_narrow_name = /** @type {(inputs: Ws_List_Narrow_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Narrow by name`)
};

export const ws_list_no_match = /** @type {(inputs: Ws_List_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing matches`)
};

export const ws_load_failed = /** @type {(inputs: Ws_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not load`)
};

export const ws_members_all = /** @type {(inputs: Ws_Members_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

export const ws_members_bulk = /** @type {(inputs: Ws_Members_BulkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions on the selected people`)
};

export const ws_members_bulk_clear = /** @type {(inputs: Ws_Members_Bulk_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear the selection`)
};

export const ws_members_bulk_remove_failed = /** @type {(inputs: Ws_Members_Bulk_Remove_FailedInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Could not remove ${i?.count} person`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Could not remove ${i?.count} people`);
	return /** @type {LocalizedString} */ ("ws_members_bulk_remove_failed");
};

export const ws_members_bulk_remove_title = /** @type {(inputs: Ws_Members_Bulk_Remove_TitleInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Remove ${i?.count} person from this workspace?`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Remove ${i?.count} people from this workspace?`);
	return /** @type {LocalizedString} */ ("ws_members_bulk_remove_title");
};

export const ws_members_col_joined = /** @type {(inputs: Ws_Members_Col_JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joined the workspace`)
};

export const ws_members_col_kind = /** @type {(inputs: Ws_Members_Col_KindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kind`)
};

export const ws_members_col_last_active = /** @type {(inputs: Ws_Members_Col_Last_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last active`)
};

export const ws_members_col_name = /** @type {(inputs: Ws_Members_Col_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

export const ws_members_col_registered = /** @type {(inputs: Ws_Members_Col_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joined trameria`)
};

export const ws_members_col_roles = /** @type {(inputs: Ws_Members_Col_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roles`)
};

export const ws_members_empty = /** @type {(inputs: Ws_Members_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No one yet`)
};

export const ws_members_filter = /** @type {(inputs: Ws_Members_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By kind and role`)
};

export const ws_members_guest_no_roles = /** @type {(inputs: Ws_Members_Guest_No_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A guest cannot hold roles.`)
};

export const ws_members_joined = /** @type {(inputs: Ws_Members_JoinedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Joined ${i?.date}`)
};

export const ws_members_kind = /** @type {(inputs: Ws_Members_KindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kind`)
};

export const ws_members_kind_failed = /** @type {(inputs: Ws_Members_Kind_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not change the kind of ${i?.name}`)
};

export const ws_members_list = /** @type {(inputs: Ws_Members_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Members`)
};

export const ws_members_make_guest = /** @type {(inputs: Ws_Members_Make_GuestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make a guest`)
};

export const ws_members_make_member = /** @type {(inputs: Ws_Members_Make_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make a member`)
};

export const ws_members_no_match = /** @type {(inputs: Ws_Members_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No one matches`)
};

export const ws_members_no_roles = /** @type {(inputs: Ws_Members_No_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There are no roles besides @everyone. Make one in Roles.`)
};

export const ws_members_not_found = /** @type {(inputs: Ws_Members_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This person is not in this workspace`)
};

export const ws_members_owner = /** @type {(inputs: Ws_Members_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Owner`)
};

export const ws_members_owner_note = /** @type {(inputs: Ws_Members_Owner_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The owner of this workspace. Made it on ${i?.date}`)
};

export const ws_members_remove = /** @type {(inputs: Ws_Members_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

export const ws_members_remove_body = /** @type {(inputs: Ws_Members_Remove_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`They also lose their roles and leave every space as member and manager. Coming back needs an invite.`)
};

export const ws_members_remove_failed = /** @type {(inputs: Ws_Members_Remove_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not remove ${i?.name}`)
};

export const ws_members_remove_label = /** @type {(inputs: Ws_Members_Remove_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

export const ws_members_remove_note = /** @type {(inputs: Ws_Members_Remove_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Removes them from this workspace`)
};

export const ws_members_remove_title = /** @type {(inputs: Ws_Members_Remove_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.name} from this workspace?`)
};

export const ws_members_roles = /** @type {(inputs: Ws_Members_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roles`)
};

export const ws_members_roles_above = /** @type {(inputs: Ws_Members_Roles_AboveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can give only roles below your own highest role.`)
};

export const ws_members_roles_failed = /** @type {(inputs: Ws_Members_Roles_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not change the roles of ${i?.name}`)
};

export const ws_members_roles_not_allowed = /** @type {(inputs: Ws_Members_Roles_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giving roles needs the permission to make, change and give roles.`)
};

export const ws_members_search = /** @type {(inputs: Ws_Members_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Narrow by name`)
};

export const ws_members_select = /** @type {(inputs: Ws_Members_SelectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Select ${i?.name}`)
};

export const ws_members_select_all = /** @type {(inputs: Ws_Members_Select_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select all`)
};

export const ws_members_selected = /** @type {(inputs: Ws_Members_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} selected`)
};

export const ws_members_to_guest_body = /** @type {(inputs: Ws_Members_To_Guest_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Their roles and space management are taken away, and they leave the spaces they can no longer see. Making them a member again does not give these back.`)
};

export const ws_members_to_guest_note = /** @type {(inputs: Ws_Members_To_Guest_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A guest sees only spaces open to everyone and the spaces they joined`)
};

export const ws_members_to_guest_title = /** @type {(inputs: Ws_Members_To_Guest_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Make ${i?.name} a guest?`)
};

export const ws_members_to_member_note = /** @type {(inputs: Ws_Members_To_Member_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As a member they see the members' spaces again`)
};

export const ws_menu = /** @type {(inputs: Ws_MenuInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Menu of ${i?.name}`)
};

export const ws_menu_invite = /** @type {(inputs: Ws_Menu_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite`)
};

export const ws_menu_new = /** @type {(inputs: Ws_Menu_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make a workspace`)
};

export const ws_menu_settings = /** @type {(inputs: Ws_Menu_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings`)
};

export const ws_missing_body = /** @type {(inputs: Ws_Missing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This workspace does not exist, or you are not in it yet. An invite link lets you join.`)
};

export const ws_missing_title = /** @type {(inputs: Ws_Missing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace not found`)
};

export const ws_my_cases = /** @type {(inputs: Ws_My_CasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Cases`)
};

export const ws_my_cases_chip = /** @type {(inputs: Ws_My_Cases_ChipInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} of my Cases links here`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} of my Cases link here`);
	return /** @type {LocalizedString} */ ("ws_my_cases_chip");
};

export const ws_new_create = /** @type {(inputs: Ws_New_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make`)
};

export const ws_new_description = /** @type {(inputs: Ws_New_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where a team keeps its conversations, documents and issues. You become its owner.`)
};

export const ws_new_failed = /** @type {(inputs: Ws_New_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not make the workspace`)
};

export const ws_new_title = /** @type {(inputs: Ws_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make a workspace`)
};

export const ws_perm_emoji_create = /** @type {(inputs: Ws_Perm_Emoji_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add emoji`)
};

export const ws_perm_emoji_manage = /** @type {(inputs: Ws_Perm_Emoji_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete anyone's emoji`)
};

export const ws_perm_issue_manage = /** @type {(inputs: Ws_Perm_Issue_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage issues and projects`)
};

export const ws_perm_member_manage = /** @type {(inputs: Ws_Perm_Member_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove members and change their kind`)
};

export const ws_perm_message_write = /** @type {(inputs: Ws_Perm_Message_WriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write in conversations`)
};

export const ws_perm_page_write = /** @type {(inputs: Ws_Perm_Page_WriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make and write documents`)
};

export const ws_perm_role_manage = /** @type {(inputs: Ws_Perm_Role_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make, change and give roles`)
};

export const ws_perm_space_manage = /** @type {(inputs: Ws_Perm_Space_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make spaces`)
};

export const ws_perm_workspace_invite = /** @type {(inputs: Ws_Perm_Workspace_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make and revoke invite links`)
};

export const ws_perm_workspace_manage = /** @type {(inputs: Ws_Perm_Workspace_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change the workspace's name, URL and features`)
};

export const ws_profile_avatar = /** @type {(inputs: Ws_Profile_AvatarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Picture`)
};

export const ws_profile_avatar_note = /** @type {(inputs: Ws_Profile_Avatar_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A picture for this workspace only. Without one, your account's picture shows`)
};

export const ws_profile_avatar_reset = /** @type {(inputs: Ws_Profile_Avatar_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Same as account`)
};

export const ws_profile_name = /** @type {(inputs: Ws_Profile_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Display name`)
};

export const ws_profile_name_note = /** @type {(inputs: Ws_Profile_Name_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The name people in this workspace see`)
};

export const ws_rail = /** @type {(inputs: Ws_RailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspaces`)
};

export const ws_rail_new = /** @type {(inputs: Ws_Rail_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make a workspace`)
};

export const ws_roles_above_you = /** @type {(inputs: Ws_Roles_Above_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You cannot change a role at or above your own highest role.`)
};

export const ws_roles_create = /** @type {(inputs: Ws_Roles_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make`)
};

export const ws_roles_create_failed = /** @type {(inputs: Ws_Roles_Create_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not make the role`)
};

export const ws_roles_default_note = /** @type {(inputs: Ws_Roles_Default_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The role everyone has. Its name and position stay, and it cannot be deleted.`)
};

export const ws_roles_default_sub = /** @type {(inputs: Ws_Roles_Default_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default (everyone)`)
};

export const ws_roles_delete_body = /** @type {(inputs: Ws_Roles_Delete_BodyInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`The ${i?.count} person with it loses it, and invite links that give it are deleted too.`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`The ${i?.count} people with it lose it, and invite links that give it are deleted too.`);
	return /** @type {LocalizedString} */ ("ws_roles_delete_body");
};

export const ws_roles_delete_failed = /** @type {(inputs: Ws_Roles_Delete_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not delete the role ${i?.name}`)
};

export const ws_roles_delete_label = /** @type {(inputs: Ws_Roles_Delete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

export const ws_roles_delete_note = /** @type {(inputs: Ws_Roles_Delete_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deletes this role`)
};

export const ws_roles_delete_title = /** @type {(inputs: Ws_Roles_Delete_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete the role ${i?.name}?`)
};

export const ws_roles_list = /** @type {(inputs: Ws_Roles_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roles`)
};

export const ws_roles_name = /** @type {(inputs: Ws_Roles_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

export const ws_roles_name_example = /** @type {(inputs: Ws_Roles_Name_ExampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Editor`)
};

export const ws_roles_new = /** @type {(inputs: Ws_Roles_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New role`)
};

export const ws_roles_not_allowed = /** @type {(inputs: Ws_Roles_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changing roles needs the permission to make, change and give roles.`)
};

export const ws_roles_not_found = /** @type {(inputs: Ws_Roles_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This role was not found`)
};

export const ws_roles_note = /** @type {(inputs: Ws_Roles_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What people with this role may do.`)
};

export const ws_roles_only_yours = /** @type {(inputs: Ws_Roles_Only_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can give only permissions you hold.`)
};

export const ws_roles_permissions = /** @type {(inputs: Ws_Roles_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permissions`)
};

export const ws_roles_permissions_failed = /** @type {(inputs: Ws_Roles_Permissions_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not change the permissions of ${i?.name}`)
};

export const ws_roles_position = /** @type {(inputs: Ws_Roles_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position`)
};

export const ws_roles_position_note = /** @type {(inputs: Ws_Roles_Position_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Higher is stronger, up to just below your own highest role`)
};

export const ws_roles_position_sub = /** @type {(inputs: Ws_Roles_Position_SubInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Level ${i?.position}`)
};

export const ws_save_failed = /** @type {(inputs: Ws_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not save`)
};

export const ws_settings_admin = /** @type {(inputs: Ws_Settings_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin`)
};

export const ws_settings_back = /** @type {(inputs: Ws_Settings_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back`)
};

export const ws_settings_features = /** @type {(inputs: Ws_Settings_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Features`)
};

export const ws_settings_features_description = /** @type {(inputs: Ws_Settings_Features_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What this workspace uses, and how it is reached from outside. A feature turned off goes from everyone's screen.`)
};

export const ws_settings_general = /** @type {(inputs: Ws_Settings_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General`)
};

export const ws_settings_general_description = /** @type {(inputs: Ws_Settings_General_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The workspace's icon, name and URL.`)
};

export const ws_settings_index_description = /** @type {(inputs: Ws_Settings_Index_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your own settings in this Workspace, and Workspace administration.`)
};

export const ws_settings_invites = /** @type {(inputs: Ws_Settings_InvitesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invites`)
};

export const ws_settings_invites_description = /** @type {(inputs: Ws_Settings_Invites_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Links to join with, limited in uses and time as you choose.`)
};

export const ws_settings_members = /** @type {(inputs: Ws_Settings_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Members`)
};

export const ws_settings_members_description = /** @type {(inputs: Ws_Settings_Members_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The people in this workspace. Change their roles and kind, or remove them.`)
};

export const ws_settings_not_allowed = /** @type {(inputs: Ws_Settings_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You may not open this setting.`)
};

export const ws_settings_of = /** @type {(inputs: Ws_Settings_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Settings of ${i?.name}`)
};

export const ws_settings_personal = /** @type {(inputs: Ws_Settings_PersonalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal`)
};

export const ws_settings_profile = /** @type {(inputs: Ws_Settings_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile`)
};

export const ws_settings_profile_description = /** @type {(inputs: Ws_Settings_Profile_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The name and picture you use in this workspace. Each workspace has its own.`)
};

export const ws_settings_roles = /** @type {(inputs: Ws_Settings_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roles`)
};

export const ws_settings_roles_description = /** @type {(inputs: Ws_Settings_Roles_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sets of what people may do. Higher roles are stronger, and you can change only roles below your own.`)
};

export const ws_settings_spaces = /** @type {(inputs: Ws_Settings_SpacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spaces`)
};

export const ws_settings_spaces_description = /** @type {(inputs: Ws_Settings_Spaces_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where conversations and documents live. Each space decides who sees it and what it uses.`)
};

export const ws_settings_title = /** @type {(inputs: Ws_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace settings`)
};

export const ws_slug_format = /** @type {(inputs: Ws_Slug_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use 3 to 32 lowercase letters, digits or -, starting and ending with a letter or digit`)
};

export const ws_slug_reserved = /** @type {(inputs: Ws_Slug_ReservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This URL cannot be used`)
};

export const ws_slug_taken = /** @type {(inputs: Ws_Slug_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This URL is taken`)
};

export const ws_spaces_add_manager = /** @type {(inputs: Ws_Spaces_Add_ManagerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a manager`)
};

export const ws_spaces_add_member = /** @type {(inputs: Ws_Spaces_Add_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a member`)
};

export const ws_spaces_anyone_note = /** @type {(inputs: Ws_Spaces_Anyone_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everyone in this workspace sees it, guests too`)
};

export const ws_spaces_archive = /** @type {(inputs: Ws_Spaces_ArchiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archive`)
};

export const ws_spaces_archive_label = /** @type {(inputs: Ws_Spaces_Archive_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archive and delete`)
};

export const ws_spaces_archive_note = /** @type {(inputs: Ws_Spaces_Archive_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takes it out of the sidebar and keeps what is in it`)
};

export const ws_spaces_archived = /** @type {(inputs: Ws_Spaces_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archived`)
};

export const ws_spaces_archived_note = /** @type {(inputs: Ws_Spaces_Archived_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archived. Not shown in the sidebar`)
};

export const ws_spaces_create = /** @type {(inputs: Ws_Spaces_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make`)
};

export const ws_spaces_create_failed = /** @type {(inputs: Ws_Spaces_Create_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not make the space`)
};

export const ws_spaces_create_not_allowed = /** @type {(inputs: Ws_Spaces_Create_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Making spaces needs the permission to make spaces.`)
};

export const ws_spaces_delete_body = /** @type {(inputs: Ws_Spaces_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Its conversations, documents and issues can no longer be seen, and its members and managers leave it.`)
};

export const ws_spaces_delete_failed = /** @type {(inputs: Ws_Spaces_Delete_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not delete the space ${i?.name}`)
};

export const ws_spaces_delete_note = /** @type {(inputs: Ws_Spaces_Delete_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deletes this space`)
};

export const ws_spaces_delete_title = /** @type {(inputs: Ws_Spaces_Delete_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete the space ${i?.name}?`)
};

export const ws_spaces_description = /** @type {(inputs: Ws_Spaces_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

export const ws_spaces_description_placeholder = /** @type {(inputs: Ws_Spaces_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What the space is for`)
};

export const ws_spaces_features = /** @type {(inputs: Ws_Spaces_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Features in use`)
};

export const ws_spaces_features_failed = /** @type {(inputs: Ws_Spaces_Features_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not change the features of ${i?.name}`)
};

export const ws_spaces_list = /** @type {(inputs: Ws_Spaces_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spaces`)
};

export const ws_spaces_managers = /** @type {(inputs: Ws_Spaces_ManagersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Managers`)
};

export const ws_spaces_members = /** @type {(inputs: Ws_Spaces_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Members`)
};

export const ws_spaces_members_note = /** @type {(inputs: Ws_Spaces_Members_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Members see it. Guests do not`)
};

export const ws_spaces_name = /** @type {(inputs: Ws_Spaces_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

export const ws_spaces_narrow = /** @type {(inputs: Ws_Spaces_NarrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change`)
};

export const ws_spaces_narrow_members_body = /** @type {(inputs: Ws_Spaces_Narrow_Members_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guests stop seeing this space at once.`)
};

export const ws_spaces_narrow_private_body = /** @type {(inputs: Ws_Spaces_Narrow_Private_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Those who are not its members stop seeing this space at once. Its managers and you become its members.`)
};

export const ws_spaces_narrow_title = /** @type {(inputs: Ws_Spaces_Narrow_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Make ${i?.name} "${i?.visibility}"?`)
};

export const ws_spaces_new = /** @type {(inputs: Ws_Spaces_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New space`)
};

export const ws_spaces_no_managers = /** @type {(inputs: Ws_Spaces_No_ManagersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No managers`)
};

export const ws_spaces_no_members = /** @type {(inputs: Ws_Spaces_No_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No members yet`)
};

export const ws_spaces_not_allowed = /** @type {(inputs: Ws_Spaces_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only the space's managers and those who manage the workspace can change it.`)
};

export const ws_spaces_not_found = /** @type {(inputs: Ws_Spaces_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This space was not found`)
};

export const ws_spaces_private_note = /** @type {(inputs: Ws_Spaces_Private_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only its members see it`)
};

export const ws_spaces_remove_person = /** @type {(inputs: Ws_Spaces_Remove_PersonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.name}`)
};

export const ws_spaces_remove_person_failed = /** @type {(inputs: Ws_Spaces_Remove_Person_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not remove ${i?.name}`)
};

export const ws_spaces_unarchive = /** @type {(inputs: Ws_Spaces_UnarchiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restore`)
};

export const ws_spaces_unarchive_note = /** @type {(inputs: Ws_Spaces_Unarchive_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puts it back in the sidebar`)
};

export const ws_spaces_visibility = /** @type {(inputs: Ws_Spaces_VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who sees it`)
};

export const ws_visibility_anyone = /** @type {(inputs: Ws_Visibility_AnyoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everyone`)
};

export const ws_visibility_members = /** @type {(inputs: Ws_Visibility_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Members only`)
};

export const ws_visibility_private = /** @type {(inputs: Ws_Visibility_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Its members only`)
};